(function () {
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9e9d"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9e9d"] = parcelRequire;
}
parcelRequire.register("g0Txk", function(module, exports) {






// Flickity main
/* eslint-disable max-params */ (function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter",
        "get-size/get-size",
        "fizzy-ui-utils/utils",
        "./cell",
        "./slide",
        "./animate"
    ], function(EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
        return factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("72Iw5")), (parcelRequire("qndlm")), (parcelRequire("8bpzM")), (parcelRequire("dhMlN")), (parcelRequire("cvxnu")), (parcelRequire("6G65u")));
    else {
        // browser global
        var _Flickity = window1.Flickity;
        window1.Flickity = factory(window1, window1.EvEmitter, window1.getSize, window1.fizzyUIUtils, _Flickity.Cell, _Flickity.Slide, _Flickity.animatePrototype);
    }
})(window, function factory(window1, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
    /* eslint-enable max-params */ "use strict";
    // vars
    var jQuery = window1.jQuery;
    var getComputedStyle = window1.getComputedStyle;
    var console = window1.console;
    function moveElements(elems, toElem) {
        elems = utils.makeArray(elems);
        while(elems.length)toElem.appendChild(elems.shift());
    }
    // -------------------------- Flickity -------------------------- //
    // globally unique identifiers
    var GUID = 0;
    // internal store of all Flickity intances
    var instances = {};
    function Flickity(element, options) {
        var queryElement = utils.getQueryElement(element);
        if (!queryElement) {
            if (console) console.error("Bad element for Flickity: " + (queryElement || element));
            return;
        }
        this.element = queryElement;
        // do not initialize twice on same element
        if (this.element.flickityGUID) {
            var instance = instances[this.element.flickityGUID];
            if (instance) instance.option(options);
            return instance;
        }
        // add jQuery
        if (jQuery) this.$element = jQuery(this.element);
        // options
        this.options = utils.extend({}, this.constructor.defaults);
        this.option(options);
        // kick things off
        this._create();
    }
    Flickity.defaults = {
        accessibility: true,
        // adaptiveHeight: false,
        cellAlign: "center",
        // cellSelector: undefined,
        // contain: false,
        freeScrollFriction: 0.075,
        friction: 0.28,
        namespaceJQueryEvents: true,
        // initialIndex: 0,
        percentPosition: true,
        resize: true,
        selectedAttraction: 0.025,
        setGallerySize: true
    };
    // hash of methods triggered on _create()
    Flickity.createMethods = [];
    var proto = Flickity.prototype;
    // inherit EventEmitter
    utils.extend(proto, EvEmitter.prototype);
    proto._create = function() {
        // add id for Flickity.data
        var id = this.guid = ++GUID;
        this.element.flickityGUID = id; // expando
        instances[id] = this; // associate via id
        // initial properties
        this.selectedIndex = 0;
        // how many frames slider has been in same position
        this.restingFrames = 0;
        // initial physics properties
        this.x = 0;
        this.velocity = 0;
        this.originSide = this.options.rightToLeft ? "right" : "left";
        // create viewport & slider
        this.viewport = document.createElement("div");
        this.viewport.className = "flickity-viewport";
        this._createSlider();
        if (this.options.resize || this.options.watchCSS) window1.addEventListener("resize", this);
        // add listeners from on option
        for(var eventName in this.options.on){
            var listener = this.options.on[eventName];
            this.on(eventName, listener);
        }
        Flickity.createMethods.forEach(function(method) {
            this[method]();
        }, this);
        if (this.options.watchCSS) this.watchCSS();
        else this.activate();
    };
    /**
 * set options
 * @param {Object} opts - options to extend
 */ proto.option = function(opts) {
        utils.extend(this.options, opts);
    };
    proto.activate = function() {
        if (this.isActive) return;
        this.isActive = true;
        this.element.classList.add("flickity-enabled");
        if (this.options.rightToLeft) this.element.classList.add("flickity-rtl");
        this.getSize();
        // move initial cell elements so they can be loaded as cells
        var cellElems = this._filterFindCellElements(this.element.children);
        moveElements(cellElems, this.slider);
        this.viewport.appendChild(this.slider);
        this.element.appendChild(this.viewport);
        // get cells from children
        this.reloadCells();
        if (this.options.accessibility) {
            // allow element to focusable
            this.element.tabIndex = 0;
            // listen for key presses
            this.element.addEventListener("keydown", this);
        }
        this.emitEvent("activate");
        this.selectInitialIndex();
        // flag for initial activation, for using initialIndex
        this.isInitActivated = true;
        // ready event. #493
        this.dispatchEvent("ready");
    };
    // slider positions the cells
    proto._createSlider = function() {
        // slider element does all the positioning
        var slider = document.createElement("div");
        slider.className = "flickity-slider";
        slider.style[this.originSide] = 0;
        this.slider = slider;
    };
    proto._filterFindCellElements = function(elems) {
        return utils.filterFindElements(elems, this.options.cellSelector);
    };
    // goes through all children
    proto.reloadCells = function() {
        // collection of item elements
        this.cells = this._makeCells(this.slider.children);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
    };
    /**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */ proto._makeCells = function(elems) {
        var cellElems = this._filterFindCellElements(elems);
        // create new Flickity for collection
        var cells = cellElems.map(function(cellElem) {
            return new Cell(cellElem, this);
        }, this);
        return cells;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.getLastSlide = function() {
        return this.slides[this.slides.length - 1];
    };
    // positions all cells
    proto.positionCells = function() {
        // size all cells
        this._sizeCells(this.cells);
        // position all cells
        this._positionCells(0);
    };
    /**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */ proto._positionCells = function(index) {
        index = index || 0;
        // also measure maxCellHeight
        // start 0 if positioning all cells
        this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
        var cellX = 0;
        // get cellX
        if (index > 0) {
            var startCell = this.cells[index - 1];
            cellX = startCell.x + startCell.size.outerWidth;
        }
        var len = this.cells.length;
        for(var i = index; i < len; i++){
            var cell = this.cells[i];
            cell.setPosition(cellX);
            cellX += cell.size.outerWidth;
            this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
        }
        // keep track of cellX for wrap-around
        this.slideableWidth = cellX;
        // slides
        this.updateSlides();
        // contain slides target
        this._containSlides();
        // update slidesWidth
        this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
    };
    /**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */ proto._sizeCells = function(cells) {
        cells.forEach(function(cell) {
            cell.getSize();
        });
    };
    // --------------------------  -------------------------- //
    proto.updateSlides = function() {
        this.slides = [];
        if (!this.cells.length) return;
        var slide = new Slide(this);
        this.slides.push(slide);
        var isOriginLeft = this.originSide == "left";
        var nextMargin = isOriginLeft ? "marginRight" : "marginLeft";
        var canCellFit = this._getCanCellFit();
        this.cells.forEach(function(cell, i) {
            // just add cell if first cell in slide
            if (!slide.cells.length) {
                slide.addCell(cell);
                return;
            }
            var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
            if (canCellFit.call(this, i, slideWidth)) slide.addCell(cell);
            else {
                // doesn't fit, new slide
                slide.updateTarget();
                slide = new Slide(this);
                this.slides.push(slide);
                slide.addCell(cell);
            }
        }, this);
        // last slide
        slide.updateTarget();
        // update .selectedSlide
        this.updateSelectedSlide();
    };
    proto._getCanCellFit = function() {
        var groupCells = this.options.groupCells;
        if (!groupCells) return function() {
            return false;
        };
        else if (typeof groupCells == "number") {
            // group by number. 3 -> [0,1,2], [3,4,5], ...
            var number = parseInt(groupCells, 10);
            return function(i) {
                return i % number !== 0;
            };
        }
        // default, group by width of slide
        // parse '75%
        var percentMatch = typeof groupCells == "string" && groupCells.match(/^(\d+)%$/);
        var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
        return function(i, slideWidth) {
            /* eslint-disable-next-line no-invalid-this */ return slideWidth <= (this.size.innerWidth + 1) * percent;
        };
    };
    // alias _init for jQuery plugin .flickity()
    proto._init = proto.reposition = function() {
        this.positionCells();
        this.positionSliderAtSelected();
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
        this.setCellAlign();
        this.cursorPosition = this.size.innerWidth * this.cellAlign;
    };
    var cellAlignShorthands = {
        // cell align, then based on origin side
        center: {
            left: 0.5,
            right: 0.5
        },
        left: {
            left: 0,
            right: 1
        },
        right: {
            right: 0,
            left: 1
        }
    };
    proto.setCellAlign = function() {
        var shorthand = cellAlignShorthands[this.options.cellAlign];
        this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
    };
    proto.setGallerySize = function() {
        if (this.options.setGallerySize) {
            var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
            this.viewport.style.height = height + "px";
        }
    };
    proto._getWrapShiftCells = function() {
        // only for wrap-around
        if (!this.options.wrapAround) return;
        // unshift previous cells
        this._unshiftCells(this.beforeShiftCells);
        this._unshiftCells(this.afterShiftCells);
        // get before cells
        // initial gap
        var gapX = this.cursorPosition;
        var cellIndex = this.cells.length - 1;
        this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
        // get after cells
        // ending gap between last cell and end of gallery viewport
        gapX = this.size.innerWidth - this.cursorPosition;
        // start cloning at first cell, working forwards
        this.afterShiftCells = this._getGapCells(gapX, 0, 1);
    };
    proto._getGapCells = function(gapX, cellIndex, increment) {
        // keep adding cells until the cover the initial gap
        var cells = [];
        while(gapX > 0){
            var cell = this.cells[cellIndex];
            if (!cell) break;
            cells.push(cell);
            cellIndex += increment;
            gapX -= cell.size.outerWidth;
        }
        return cells;
    };
    // ----- contain ----- //
    // contain cell targets so no excess sliding
    proto._containSlides = function() {
        if (!this.options.contain || this.options.wrapAround || !this.cells.length) return;
        var isRightToLeft = this.options.rightToLeft;
        var beginMargin = isRightToLeft ? "marginRight" : "marginLeft";
        var endMargin = isRightToLeft ? "marginLeft" : "marginRight";
        var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
        // content is less than gallery size
        var isContentSmaller = contentWidth < this.size.innerWidth;
        // bounds
        var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
        var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
        // contain each cell target
        this.slides.forEach(function(slide) {
            if (isContentSmaller) // all cells fit inside gallery
            slide.target = contentWidth * this.cellAlign;
            else {
                // contain to bounds
                slide.target = Math.max(slide.target, beginBound);
                slide.target = Math.min(slide.target, endBound);
            }
        }, this);
    };
    // -----  ----- //
    /**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */ proto.dispatchEvent = function(type, event, args) {
        var emitArgs = event ? [
            event
        ].concat(args) : args;
        this.emitEvent(type, emitArgs);
        if (jQuery && this.$element) {
            // default trigger with type if no event
            type += this.options.namespaceJQueryEvents ? ".flickity" : "";
            var $event = type;
            if (event) {
                // create jQuery event
                var jQEvent = new jQuery.Event(event);
                jQEvent.type = type;
                $event = jQEvent;
            }
            this.$element.trigger($event, args);
        }
    };
    // -------------------------- select -------------------------- //
    /**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */ proto.select = function(index, isWrap, isInstant) {
        if (!this.isActive) return;
        index = parseInt(index, 10);
        this._wrapSelect(index);
        if (this.options.wrapAround || isWrap) index = utils.modulo(index, this.slides.length);
        // bail if invalid index
        if (!this.slides[index]) return;
        var prevIndex = this.selectedIndex;
        this.selectedIndex = index;
        this.updateSelectedSlide();
        if (isInstant) this.positionSliderAtSelected();
        else this.startAnimation();
        if (this.options.adaptiveHeight) this.setGallerySize();
        // events
        this.dispatchEvent("select", null, [
            index
        ]);
        // change event if new index
        if (index != prevIndex) this.dispatchEvent("change", null, [
            index
        ]);
        // old v1 event name, remove in v3
        this.dispatchEvent("cellSelect");
    };
    // wraps position for wrapAround, to move to closest slide. #113
    proto._wrapSelect = function(index) {
        var len = this.slides.length;
        var isWrapping = this.options.wrapAround && len > 1;
        if (!isWrapping) return index;
        var wrapIndex = utils.modulo(index, len);
        // go to shortest
        var delta = Math.abs(wrapIndex - this.selectedIndex);
        var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
        var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
        if (!this.isDragSelect && backWrapDelta < delta) index += len;
        else if (!this.isDragSelect && forewardWrapDelta < delta) index -= len;
        // wrap position so slider is within normal area
        if (index < 0) this.x -= this.slideableWidth;
        else if (index >= len) this.x += this.slideableWidth;
    };
    proto.previous = function(isWrap, isInstant) {
        this.select(this.selectedIndex - 1, isWrap, isInstant);
    };
    proto.next = function(isWrap, isInstant) {
        this.select(this.selectedIndex + 1, isWrap, isInstant);
    };
    proto.updateSelectedSlide = function() {
        var slide = this.slides[this.selectedIndex];
        // selectedIndex could be outside of slides, if triggered before resize()
        if (!slide) return;
        // unselect previous selected slide
        this.unselectSelectedSlide();
        // update new selected slide
        this.selectedSlide = slide;
        slide.select();
        this.selectedCells = slide.cells;
        this.selectedElements = slide.getCellElements();
        // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
        // Remove in v3?
        this.selectedCell = slide.cells[0];
        this.selectedElement = this.selectedElements[0];
    };
    proto.unselectSelectedSlide = function() {
        if (this.selectedSlide) this.selectedSlide.unselect();
    };
    proto.selectInitialIndex = function() {
        var initialIndex = this.options.initialIndex;
        // already activated, select previous selectedIndex
        if (this.isInitActivated) {
            this.select(this.selectedIndex, false, true);
            return;
        }
        // select with selector string
        if (initialIndex && typeof initialIndex == "string") {
            var cell = this.queryCell(initialIndex);
            if (cell) {
                this.selectCell(initialIndex, false, true);
                return;
            }
        }
        var index = 0;
        // select with number
        if (initialIndex && this.slides[initialIndex]) index = initialIndex;
        // select instantly
        this.select(index, false, true);
    };
    /**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */ proto.selectCell = function(value, isWrap, isInstant) {
        // get cell
        var cell = this.queryCell(value);
        if (!cell) return;
        var index = this.getCellSlideIndex(cell);
        this.select(index, isWrap, isInstant);
    };
    proto.getCellSlideIndex = function(cell) {
        // get index of slides that has cell
        for(var i = 0; i < this.slides.length; i++){
            var slide = this.slides[i];
            var index = slide.cells.indexOf(cell);
            if (index != -1) return i;
        }
    };
    // -------------------------- get cells -------------------------- //
    /**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */ proto.getCell = function(elem) {
        // loop through cells to get the one that matches
        for(var i = 0; i < this.cells.length; i++){
            var cell = this.cells[i];
            if (cell.element == elem) return cell;
        }
    };
    /**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */ proto.getCells = function(elems) {
        elems = utils.makeArray(elems);
        var cells = [];
        elems.forEach(function(elem) {
            var cell = this.getCell(elem);
            if (cell) cells.push(cell);
        }, this);
        return cells;
    };
    /**
 * get cell elements
 * @returns {Array} cellElems
 */ proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    /**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */ proto.getParentCell = function(elem) {
        // first check if elem is cell
        var cell = this.getCell(elem);
        if (cell) return cell;
        // try to get parent cell elem
        elem = utils.getParent(elem, ".flickity-slider > *");
        return this.getCell(elem);
    };
    /**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */ proto.getAdjacentCellElements = function(adjCount, index) {
        if (!adjCount) return this.selectedSlide.getCellElements();
        index = index === undefined ? this.selectedIndex : index;
        var len = this.slides.length;
        if (1 + adjCount * 2 >= len) return this.getCellElements();
        var cellElems = [];
        for(var i = index - adjCount; i <= index + adjCount; i++){
            var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
            var slide = this.slides[slideIndex];
            if (slide) cellElems = cellElems.concat(slide.getCellElements());
        }
        return cellElems;
    };
    /**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */ proto.queryCell = function(selector) {
        if (typeof selector == "number") // use number as index
        return this.cells[selector];
        if (typeof selector == "string") {
            // do not select invalid selectors from hash: #123, #/. #791
            if (selector.match(/^[#.]?[\d/]/)) return;
            // use string as selector, get element
            selector = this.element.querySelector(selector);
        }
        // get cell from element
        return this.getCell(selector);
    };
    // -------------------------- events -------------------------- //
    proto.uiChange = function() {
        this.emitEvent("uiChange");
    };
    // keep focus on element when child UI elements are clicked
    proto.childUIPointerDown = function(event) {
        // HACK iOS does not allow touch events to bubble up?!
        if (event.type != "touchstart") event.preventDefault();
        this.focus();
    };
    // ----- resize ----- //
    proto.onresize = function() {
        this.watchCSS();
        this.resize();
    };
    utils.debounceMethod(Flickity, "onresize", 150);
    proto.resize = function() {
        if (!this.isActive) return;
        this.getSize();
        // wrap values
        if (this.options.wrapAround) this.x = utils.modulo(this.x, this.slideableWidth);
        this.positionCells();
        this._getWrapShiftCells();
        this.setGallerySize();
        this.emitEvent("resize");
        // update selected index for group slides, instant
        // TODO: position can be lost between groups of various numbers
        var selectedElement = this.selectedElements && this.selectedElements[0];
        this.selectCell(selectedElement, false, true);
    };
    // watches the :after property, activates/deactivates
    proto.watchCSS = function() {
        var watchOption = this.options.watchCSS;
        if (!watchOption) return;
        var afterContent = getComputedStyle(this.element, ":after").content;
        // activate if :after { content: 'flickity' }
        if (afterContent.indexOf("flickity") != -1) this.activate();
        else this.deactivate();
    };
    // ----- keydown ----- //
    // go previous/next if left/right keys pressed
    proto.onkeydown = function(event) {
        // only work if element is in focus
        var isNotFocused = document.activeElement && document.activeElement != this.element;
        if (!this.options.accessibility || isNotFocused) return;
        var handler = Flickity.keyboardHandlers[event.keyCode];
        if (handler) handler.call(this);
    };
    Flickity.keyboardHandlers = {
        // left arrow
        37: function() {
            var leftMethod = this.options.rightToLeft ? "next" : "previous";
            this.uiChange();
            this[leftMethod]();
        },
        // right arrow
        39: function() {
            var rightMethod = this.options.rightToLeft ? "previous" : "next";
            this.uiChange();
            this[rightMethod]();
        }
    };
    // ----- focus ----- //
    proto.focus = function() {
        // TODO remove scrollTo once focus options gets more support
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
        //    #Browser_compatibility
        var prevScrollY = window1.pageYOffset;
        this.element.focus({
            preventScroll: true
        });
        // hack to fix scroll jump after focus, #76
        if (window1.pageYOffset != prevScrollY) window1.scrollTo(window1.pageXOffset, prevScrollY);
    };
    // -------------------------- destroy -------------------------- //
    // deactivate all Flickity functionality, but keep stuff available
    proto.deactivate = function() {
        if (!this.isActive) return;
        this.element.classList.remove("flickity-enabled");
        this.element.classList.remove("flickity-rtl");
        this.unselectSelectedSlide();
        // destroy cells
        this.cells.forEach(function(cell) {
            cell.destroy();
        });
        this.element.removeChild(this.viewport);
        // move child elements back into element
        moveElements(this.slider.children, this.element);
        if (this.options.accessibility) {
            this.element.removeAttribute("tabIndex");
            this.element.removeEventListener("keydown", this);
        }
        // set flags
        this.isActive = false;
        this.emitEvent("deactivate");
    };
    proto.destroy = function() {
        this.deactivate();
        window1.removeEventListener("resize", this);
        this.allOff();
        this.emitEvent("destroy");
        if (jQuery && this.$element) jQuery.removeData(this.element, "flickity");
        delete this.element.flickityGUID;
        delete instances[this.guid];
    };
    // -------------------------- prototype -------------------------- //
    utils.extend(proto, animatePrototype);
    // -------------------------- extras -------------------------- //
    /**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */ Flickity.data = function(elem) {
        elem = utils.getQueryElement(elem);
        var id = elem && elem.flickityGUID;
        return id && instances[id];
    };
    utils.htmlInit(Flickity, "flickity");
    if (jQuery && jQuery.bridget) jQuery.bridget("flickity", Flickity);
    // set internal jQuery, for Webpack + jQuery v3, #478
    Flickity.setJQuery = function(jq) {
        jQuery = jq;
    };
    Flickity.Cell = Cell;
    Flickity.Slide = Slide;
    return Flickity;
});

});
parcelRequire.register("72Iw5", function(module, exports) {
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */ /* jshint unused: true, undef: true, strict: true */ (function(global, factory) {
    // universal module definition
    /* jshint strict: false */ /* globals define, module, window */ if (typeof define == "function" && define.amd) // AMD - RequireJS
    define(factory);
    else if (0, module.exports) // CommonJS - Browserify, Webpack
    module.exports = factory();
    else // Browser globals
    global.EvEmitter = factory();
})(typeof window != "undefined" ? window : module.exports, function() {
    "use strict";
    function EvEmitter() {}
    var proto = EvEmitter.prototype;
    proto.on = function(eventName, listener) {
        if (!eventName || !listener) return;
        // set events hash
        var events = this._events = this._events || {};
        // set listeners array
        var listeners = events[eventName] = events[eventName] || [];
        // only add once
        if (listeners.indexOf(listener) == -1) listeners.push(listener);
        return this;
    };
    proto.once = function(eventName, listener) {
        if (!eventName || !listener) return;
        // add event
        this.on(eventName, listener);
        // set once flag
        // set onceEvents hash
        var onceEvents = this._onceEvents = this._onceEvents || {};
        // set onceListeners object
        var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
        // set flag
        onceListeners[listener] = true;
        return this;
    };
    proto.off = function(eventName, listener) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        var index = listeners.indexOf(listener);
        if (index != -1) listeners.splice(index, 1);
        return this;
    };
    proto.emitEvent = function(eventName, args) {
        var listeners = this._events && this._events[eventName];
        if (!listeners || !listeners.length) return;
        // copy over to avoid interference if .off() in listener
        listeners = listeners.slice(0);
        args = args || [];
        // once stuff
        var onceListeners = this._onceEvents && this._onceEvents[eventName];
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            var isOnce = onceListeners && onceListeners[listener];
            if (isOnce) {
                // remove listener
                // remove before trigger to prevent recursion
                this.off(eventName, listener);
                // unset once flag
                delete onceListeners[listener];
            }
            // trigger listener
            listener.apply(this, args);
        }
        return this;
    };
    proto.allOff = function() {
        delete this._events;
        delete this._onceEvents;
    };
    return EvEmitter;
});

});

parcelRequire.register("qndlm", function(module, exports) {
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */ /* jshint browser: true, strict: true, undef: true, unused: true */ /* globals console: false */ (function(window1, factory) {
    /* jshint strict: false */ /* globals define, module */ if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.getSize = factory();
})(window, function factory() {
    "use strict";
    // -------------------------- helpers -------------------------- //
    // get a number from a string, not a percentage
    function getStyleSize(value) {
        var num = parseFloat(value);
        // not a percent like '100%', and a number
        var isValid = value.indexOf("%") == -1 && !isNaN(num);
        return isValid && num;
    }
    function noop() {}
    var logError = typeof console == "undefined" ? noop : function(message) {
        console.error(message);
    };
    // -------------------------- measurements -------------------------- //
    var measurements = [
        "paddingLeft",
        "paddingRight",
        "paddingTop",
        "paddingBottom",
        "marginLeft",
        "marginRight",
        "marginTop",
        "marginBottom",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth",
        "borderBottomWidth"
    ];
    var measurementsLength = measurements.length;
    function getZeroSize() {
        var size = {
            width: 0,
            height: 0,
            innerWidth: 0,
            innerHeight: 0,
            outerWidth: 0,
            outerHeight: 0
        };
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            size[measurement] = 0;
        }
        return size;
    }
    // -------------------------- getStyle -------------------------- //
    /**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */ function getStyle(elem) {
        var style = getComputedStyle(elem);
        if (!style) logError("Style returned " + style + ". Are you running this code in a hidden iframe on Firefox? " + "See https://bit.ly/getsizebug1");
        return style;
    }
    // -------------------------- setup -------------------------- //
    var isSetup = false;
    var isBoxSizeOuter;
    /**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */ function setup() {
        // setup once
        if (isSetup) return;
        isSetup = true;
        // -------------------------- box sizing -------------------------- //
        /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */ var div = document.createElement("div");
        div.style.width = "200px";
        div.style.padding = "1px 2px 3px 4px";
        div.style.borderStyle = "solid";
        div.style.borderWidth = "1px 2px 3px 4px";
        div.style.boxSizing = "border-box";
        var body = document.body || document.documentElement;
        body.appendChild(div);
        var style = getStyle(div);
        // round value for browser zoom. desandro/masonry#928
        isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
        getSize.isBoxSizeOuter = isBoxSizeOuter;
        body.removeChild(div);
    }
    // -------------------------- getSize -------------------------- //
    function getSize(elem) {
        setup();
        // use querySeletor if elem is string
        if (typeof elem == "string") elem = document.querySelector(elem);
        // do not proceed on non-objects
        if (!elem || typeof elem != "object" || !elem.nodeType) return;
        var style = getStyle(elem);
        // if hidden, everything is 0
        if (style.display == "none") return getZeroSize();
        var size = {};
        size.width = elem.offsetWidth;
        size.height = elem.offsetHeight;
        var isBorderBox = size.isBorderBox = style.boxSizing == "border-box";
        // get all measurements
        for(var i = 0; i < measurementsLength; i++){
            var measurement = measurements[i];
            var value = style[measurement];
            var num = parseFloat(value);
            // any 'auto', 'medium' value will be 0
            size[measurement] = !isNaN(num) ? num : 0;
        }
        var paddingWidth = size.paddingLeft + size.paddingRight;
        var paddingHeight = size.paddingTop + size.paddingBottom;
        var marginWidth = size.marginLeft + size.marginRight;
        var marginHeight = size.marginTop + size.marginBottom;
        var borderWidth = size.borderLeftWidth + size.borderRightWidth;
        var borderHeight = size.borderTopWidth + size.borderBottomWidth;
        var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;
        // overwrite width and height if we can get it from style
        var styleWidth = getStyleSize(style.width);
        if (styleWidth !== false) size.width = styleWidth + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
        var styleHeight = getStyleSize(style.height);
        if (styleHeight !== false) size.height = styleHeight + // add padding and border unless it's already including it
        (isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
        size.innerWidth = size.width - (paddingWidth + borderWidth);
        size.innerHeight = size.height - (paddingHeight + borderHeight);
        size.outerWidth = size.width + marginWidth;
        size.outerHeight = size.height + marginHeight;
        return size;
    }
    return getSize;
});

});

parcelRequire.register("8bpzM", function(module, exports) {

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "desandro-matches-selector/matches-selector"
    ], function(matchesSelector) {
        return factory(window1, matchesSelector);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("l8zBQ")));
    else // browser global
    window1.fizzyUIUtils = factory(window1, window1.matchesSelector);
})(window, function factory(window1, matchesSelector) {
    "use strict";
    var utils = {};
    // ----- extend ----- //
    // extends objects
    utils.extend = function(a, b) {
        for(var prop in b)a[prop] = b[prop];
        return a;
    };
    // ----- modulo ----- //
    utils.modulo = function(num, div) {
        return (num % div + div) % div;
    };
    // ----- makeArray ----- //
    var arraySlice = Array.prototype.slice;
    // turn element or nodeList into an array
    utils.makeArray = function(obj) {
        if (Array.isArray(obj)) // use object if already an array
        return obj;
        // return empty array if undefined or null. #6
        if (obj === null || obj === undefined) return [];
        var isArrayLike = typeof obj == "object" && typeof obj.length == "number";
        if (isArrayLike) // convert nodeList to array
        return arraySlice.call(obj);
        // array of single index
        return [
            obj
        ];
    };
    // ----- removeFrom ----- //
    utils.removeFrom = function(ary, obj) {
        var index = ary.indexOf(obj);
        if (index != -1) ary.splice(index, 1);
    };
    // ----- getParent ----- //
    utils.getParent = function(elem, selector) {
        while(elem.parentNode && elem != document.body){
            elem = elem.parentNode;
            if (matchesSelector(elem, selector)) return elem;
        }
    };
    // ----- getQueryElement ----- //
    // use element as selector string
    utils.getQueryElement = function(elem) {
        if (typeof elem == "string") return document.querySelector(elem);
        return elem;
    };
    // ----- handleEvent ----- //
    // enable .ontype to trigger from .addEventListener( elem, 'type' )
    utils.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // ----- filterFindElements ----- //
    utils.filterFindElements = function(elems, selector) {
        // make array of elems
        elems = utils.makeArray(elems);
        var ffElems = [];
        elems.forEach(function(elem) {
            // check that elem is an actual element
            if (!(elem instanceof HTMLElement)) return;
            // add elem if no selector
            if (!selector) {
                ffElems.push(elem);
                return;
            }
            // filter & find items if we have a selector
            // filter
            if (matchesSelector(elem, selector)) ffElems.push(elem);
            // find children
            var childElems = elem.querySelectorAll(selector);
            // concat childElems to filterFound array
            for(var i = 0; i < childElems.length; i++)ffElems.push(childElems[i]);
        });
        return ffElems;
    };
    // ----- debounceMethod ----- //
    utils.debounceMethod = function(_class, methodName, threshold) {
        threshold = threshold || 100;
        // original method
        var method = _class.prototype[methodName];
        var timeoutName = methodName + "Timeout";
        _class.prototype[methodName] = function() {
            var timeout = this[timeoutName];
            clearTimeout(timeout);
            var args = arguments;
            var _this = this;
            this[timeoutName] = setTimeout(function() {
                method.apply(_this, args);
                delete _this[timeoutName];
            }, threshold);
        };
    };
    // ----- docReady ----- //
    utils.docReady = function(callback) {
        var readyState = document.readyState;
        if (readyState == "complete" || readyState == "interactive") // do async to allow for other scripts to run. metafizzy/flickity#441
        setTimeout(callback);
        else document.addEventListener("DOMContentLoaded", callback);
    };
    // ----- htmlInit ----- //
    // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
    utils.toDashed = function(str) {
        return str.replace(/(.)([A-Z])/g, function(match, $1, $2) {
            return $1 + "-" + $2;
        }).toLowerCase();
    };
    var console = window1.console;
    /**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */ utils.htmlInit = function(WidgetClass, namespace) {
        utils.docReady(function() {
            var dashedNamespace = utils.toDashed(namespace);
            var dataAttr = "data-" + dashedNamespace;
            var dataAttrElems = document.querySelectorAll("[" + dataAttr + "]");
            var jsDashElems = document.querySelectorAll(".js-" + dashedNamespace);
            var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
            var dataOptionsAttr = dataAttr + "-options";
            var jQuery = window1.jQuery;
            elems.forEach(function(elem) {
                var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
                var options;
                try {
                    options = attr && JSON.parse(attr);
                } catch (error) {
                    // log error, do not initialize
                    if (console) console.error("Error parsing " + dataAttr + " on " + elem.className + ": " + error);
                    return;
                }
                // initialize
                var instance = new WidgetClass(elem, options);
                // make available via $().data('namespace')
                if (jQuery) jQuery.data(elem, namespace, instance);
            });
        });
    };
    // -----  ----- //
    return utils;
});

});
parcelRequire.register("l8zBQ", function(module, exports) {
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */ /*jshint browser: true, strict: true, undef: true, unused: true */ (function(window1, factory) {
    /*global define: false, module: false */ "use strict";
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else // browser global
    window1.matchesSelector = factory();
})(window, function factory() {
    "use strict";
    var matchesMethod = function() {
        var ElemProto = window.Element.prototype;
        // check for the standard method name first
        if (ElemProto.matches) return "matches";
        // check un-prefixed
        if (ElemProto.matchesSelector) return "matchesSelector";
        // check vendor prefixes
        var prefixes = [
            "webkit",
            "moz",
            "ms",
            "o"
        ];
        for(var i = 0; i < prefixes.length; i++){
            var prefix = prefixes[i];
            var method = prefix + "MatchesSelector";
            if (ElemProto[method]) return method;
        }
    }();
    return function matchesSelector(elem, selector) {
        return elem[matchesMethod](selector);
    };
});

});


parcelRequire.register("dhMlN", function(module, exports) {

// Flickity.Cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "get-size/get-size"
    ], function(getSize) {
        return factory(window1, getSize);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("qndlm")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Cell = factory(window1, window1.getSize);
    }
})(window, function factory(window1, getSize) {
    "use strict";
    function Cell(elem, parent) {
        this.element = elem;
        this.parent = parent;
        this.create();
    }
    var proto = Cell.prototype;
    proto.create = function() {
        this.element.style.position = "absolute";
        this.element.setAttribute("aria-hidden", "true");
        this.x = 0;
        this.shift = 0;
    };
    proto.destroy = function() {
        // reset style
        this.unselect();
        this.element.style.position = "";
        var side = this.parent.originSide;
        this.element.style[side] = "";
        this.element.removeAttribute("aria-hidden");
    };
    proto.getSize = function() {
        this.size = getSize(this.element);
    };
    proto.setPosition = function(x) {
        this.x = x;
        this.updateTarget();
        this.renderPosition(x);
    };
    // setDefaultTarget v1 method, backwards compatibility, remove in v3
    proto.updateTarget = proto.setDefaultTarget = function() {
        var marginProperty = this.parent.originSide == "left" ? "marginLeft" : "marginRight";
        this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
    };
    proto.renderPosition = function(x) {
        // render position of cell with in slider
        var side = this.parent.originSide;
        this.element.style[side] = this.parent.getPositionValue(x);
    };
    proto.select = function() {
        this.element.classList.add("is-selected");
        this.element.removeAttribute("aria-hidden");
    };
    proto.unselect = function() {
        this.element.classList.remove("is-selected");
        this.element.setAttribute("aria-hidden", "true");
    };
    /**
 * @param {Integer} shift - 0, 1, or -1
 */ proto.wrapShift = function(shift) {
        this.shift = shift;
        this.renderPosition(this.x + this.parent.slideableWidth * shift);
    };
    proto.remove = function() {
        this.element.parentNode.removeChild(this.element);
    };
    return Cell;
});

});

parcelRequire.register("cvxnu", function(module, exports) {
// slide
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define(factory);
    else if (0, module.exports) // CommonJS
    module.exports = factory();
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.Slide = factory();
    }
})(window, function factory() {
    "use strict";
    function Slide(parent) {
        this.parent = parent;
        this.isOriginLeft = parent.originSide == "left";
        this.cells = [];
        this.outerWidth = 0;
        this.height = 0;
    }
    var proto = Slide.prototype;
    proto.addCell = function(cell) {
        this.cells.push(cell);
        this.outerWidth += cell.size.outerWidth;
        this.height = Math.max(cell.size.outerHeight, this.height);
        // first cell stuff
        if (this.cells.length == 1) {
            this.x = cell.x; // x comes from first cell
            var beginMargin = this.isOriginLeft ? "marginLeft" : "marginRight";
            this.firstMargin = cell.size[beginMargin];
        }
    };
    proto.updateTarget = function() {
        var endMargin = this.isOriginLeft ? "marginRight" : "marginLeft";
        var lastCell = this.getLastCell();
        var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
        var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
        this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
    };
    proto.getLastCell = function() {
        return this.cells[this.cells.length - 1];
    };
    proto.select = function() {
        this.cells.forEach(function(cell) {
            cell.select();
        });
    };
    proto.unselect = function() {
        this.cells.forEach(function(cell) {
            cell.unselect();
        });
    };
    proto.getCellElements = function() {
        return this.cells.map(function(cell) {
            return cell.element;
        });
    };
    return Slide;
});

});

parcelRequire.register("6G65u", function(module, exports) {

// animate
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "fizzy-ui-utils/utils"
    ], function(utils) {
        return factory(window1, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("8bpzM")));
    else {
        // browser global
        window1.Flickity = window1.Flickity || {};
        window1.Flickity.animatePrototype = factory(window1, window1.fizzyUIUtils);
    }
})(window, function factory(window1, utils) {
    "use strict";
    // -------------------------- animate -------------------------- //
    var proto = {};
    proto.startAnimation = function() {
        if (this.isAnimating) return;
        this.isAnimating = true;
        this.restingFrames = 0;
        this.animate();
    };
    proto.animate = function() {
        this.applyDragForce();
        this.applySelectedAttraction();
        var previousX = this.x;
        this.integratePhysics();
        this.positionSlider();
        this.settle(previousX);
        // animate next frame
        if (this.isAnimating) {
            var _this = this;
            requestAnimationFrame(function animateFrame() {
                _this.animate();
            });
        }
    };
    proto.positionSlider = function() {
        var x = this.x;
        // wrap position around
        if (this.options.wrapAround && this.cells.length > 1) {
            x = utils.modulo(x, this.slideableWidth);
            x -= this.slideableWidth;
            this.shiftWrapCells(x);
        }
        this.setTranslateX(x, this.isAnimating);
        this.dispatchScrollEvent();
    };
    proto.setTranslateX = function(x, is3d) {
        x += this.cursorPosition;
        // reverse if right-to-left and using transform
        x = this.options.rightToLeft ? -x : x;
        var translateX = this.getPositionValue(x);
        // use 3D transforms for hardware acceleration on iOS
        // but use 2D when settled, for better font-rendering
        this.slider.style.transform = is3d ? "translate3d(" + translateX + ",0,0)" : "translateX(" + translateX + ")";
    };
    proto.dispatchScrollEvent = function() {
        var firstSlide = this.slides[0];
        if (!firstSlide) return;
        var positionX = -this.x - firstSlide.target;
        var progress = positionX / this.slidesWidth;
        this.dispatchEvent("scroll", null, [
            progress,
            positionX
        ]);
    };
    proto.positionSliderAtSelected = function() {
        if (!this.cells.length) return;
        this.x = -this.selectedSlide.target;
        this.velocity = 0; // stop wobble
        this.positionSlider();
    };
    proto.getPositionValue = function(position) {
        if (this.options.percentPosition) // percent position, round to 2 digits, like 12.34%
        return Math.round(position / this.size.innerWidth * 10000) * 0.01 + "%";
        else // pixel positioning
        return Math.round(position) + "px";
    };
    proto.settle = function(previousX) {
        // keep track of frames where x hasn't moved
        var isResting = !this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100);
        if (isResting) this.restingFrames++;
        // stop animating if resting for 3 or more frames
        if (this.restingFrames > 2) {
            this.isAnimating = false;
            delete this.isFreeScrolling;
            // render position with translateX when settled
            this.positionSlider();
            this.dispatchEvent("settle", null, [
                this.selectedIndex
            ]);
        }
    };
    proto.shiftWrapCells = function(x) {
        // shift before cells
        var beforeGap = this.cursorPosition + x;
        this._shiftCells(this.beforeShiftCells, beforeGap, -1);
        // shift after cells
        var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
        this._shiftCells(this.afterShiftCells, afterGap, 1);
    };
    proto._shiftCells = function(cells, gap, shift) {
        for(var i = 0; i < cells.length; i++){
            var cell = cells[i];
            var cellShift = gap > 0 ? shift : 0;
            cell.wrapShift(cellShift);
            gap -= cell.size.outerWidth;
        }
    };
    proto._unshiftCells = function(cells) {
        if (!cells || !cells.length) return;
        for(var i = 0; i < cells.length; i++)cells[i].wrapShift(0);
    };
    // -------------------------- physics -------------------------- //
    proto.integratePhysics = function() {
        this.x += this.velocity;
        this.velocity *= this.getFrictionFactor();
    };
    proto.applyForce = function(force) {
        this.velocity += force;
    };
    proto.getFrictionFactor = function() {
        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
    };
    proto.getRestingPosition = function() {
        // my thanks to Steven Wittens, who simplified this math greatly
        return this.x + this.velocity / (1 - this.getFrictionFactor());
    };
    proto.applyDragForce = function() {
        if (!this.isDraggable || !this.isPointerDown) return;
        // change the position to drag position by applying force
        var dragVelocity = this.dragX - this.x;
        var dragForce = dragVelocity - this.velocity;
        this.applyForce(dragForce);
    };
    proto.applySelectedAttraction = function() {
        // do not attract if pointer down or no slides
        var dragDown = this.isDraggable && this.isPointerDown;
        if (dragDown || this.isFreeScrolling || !this.slides.length) return;
        var distance = this.selectedSlide.target * -1 - this.x;
        var force = distance * this.options.selectedAttraction;
        this.applyForce(force);
    };
    return proto;
});

});


parcelRequire.register("40VrA", function(module, exports) {



// drag
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unidragger/unidragger",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unidragger, utils) {
        return factory(window1, Flickity, Unidragger, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("g0Txk")), (parcelRequire("2Ao6B")), (parcelRequire("8bpzM")));
    else // browser global
    window1.Flickity = factory(window1, window1.Flickity, window1.Unidragger, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unidragger, utils) {
    "use strict";
    // ----- defaults ----- //
    utils.extend(Flickity.defaults, {
        draggable: ">1",
        dragThreshold: 3
    });
    // ----- create ----- //
    Flickity.createMethods.push("_createDrag");
    // -------------------------- drag prototype -------------------------- //
    var proto = Flickity.prototype;
    utils.extend(proto, Unidragger.prototype);
    proto._touchActionValue = "pan-y";
    // --------------------------  -------------------------- //
    var isTouch = "createTouch" in document;
    var isTouchmoveScrollCanceled = false;
    proto._createDrag = function() {
        this.on("activate", this.onActivateDrag);
        this.on("uiChange", this._uiChangeDrag);
        this.on("deactivate", this.onDeactivateDrag);
        this.on("cellChange", this.updateDraggable);
        // TODO updateDraggable on resize? if groupCells & slides change
        // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
        // #457, RubaXa/Sortable#973
        if (isTouch && !isTouchmoveScrollCanceled) {
            window1.addEventListener("touchmove", function() {});
            isTouchmoveScrollCanceled = true;
        }
    };
    proto.onActivateDrag = function() {
        this.handles = [
            this.viewport
        ];
        this.bindHandles();
        this.updateDraggable();
    };
    proto.onDeactivateDrag = function() {
        this.unbindHandles();
        this.element.classList.remove("is-draggable");
    };
    proto.updateDraggable = function() {
        // disable dragging if less than 2 slides. #278
        if (this.options.draggable == ">1") this.isDraggable = this.slides.length > 1;
        else this.isDraggable = this.options.draggable;
        if (this.isDraggable) this.element.classList.add("is-draggable");
        else this.element.classList.remove("is-draggable");
    };
    // backwards compatibility
    proto.bindDrag = function() {
        this.options.draggable = true;
        this.updateDraggable();
    };
    proto.unbindDrag = function() {
        this.options.draggable = false;
        this.updateDraggable();
    };
    proto._uiChangeDrag = function() {
        delete this.isFreeScrolling;
    };
    // -------------------------- pointer events -------------------------- //
    proto.pointerDown = function(event, pointer) {
        if (!this.isDraggable) {
            this._pointerDownDefault(event, pointer);
            return;
        }
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        this._pointerDownPreventDefault(event);
        this.pointerDownFocus(event);
        // blur
        if (document.activeElement != this.element) // do not blur if already focused
        this.pointerDownBlur();
        // stop if it was moving
        this.dragX = this.x;
        this.viewport.classList.add("is-pointer-down");
        // track scrolling
        this.pointerDownScroll = getScrollPosition();
        window1.addEventListener("scroll", this);
        this._pointerDownDefault(event, pointer);
    };
    // default pointerDown logic, used for staticClick
    proto._pointerDownDefault = function(event, pointer) {
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        // bind move and end events
        this._bindPostStartEvents(event);
        this.dispatchEvent("pointerDown", event, [
            pointer
        ]);
    };
    var focusNodes = {
        INPUT: true,
        TEXTAREA: true,
        SELECT: true
    };
    proto.pointerDownFocus = function(event) {
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isFocusNode) this.focus();
    };
    proto._pointerDownPreventDefault = function(event) {
        var isTouchStart = event.type == "touchstart";
        var isTouchPointer = event.pointerType == "touch";
        var isFocusNode = focusNodes[event.target.nodeName];
        if (!isTouchStart && !isTouchPointer && !isFocusNode) event.preventDefault();
    };
    // ----- move ----- //
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > this.options.dragThreshold;
    };
    // ----- up ----- //
    proto.pointerUp = function(event, pointer) {
        delete this.isTouchScrolling;
        this.viewport.classList.remove("is-pointer-down");
        this.dispatchEvent("pointerUp", event, [
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto.pointerDone = function() {
        window1.removeEventListener("scroll", this);
        delete this.pointerDownScroll;
    };
    // -------------------------- dragging -------------------------- //
    proto.dragStart = function(event, pointer) {
        if (!this.isDraggable) return;
        this.dragStartPosition = this.x;
        this.startAnimation();
        window1.removeEventListener("scroll", this);
        this.dispatchEvent("dragStart", event, [
            pointer
        ]);
    };
    proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.dispatchEvent("pointerMove", event, [
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        if (!this.isDraggable) return;
        event.preventDefault();
        this.previousDragX = this.dragX;
        // reverse if right-to-left
        var direction = this.options.rightToLeft ? -1 : 1;
        if (this.options.wrapAround) // wrap around move. #589
        moveVector.x %= this.slideableWidth;
        var dragX = this.dragStartPosition + moveVector.x * direction;
        if (!this.options.wrapAround && this.slides.length) {
            // slow drag
            var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
            dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
            var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
            dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
        }
        this.dragX = dragX;
        this.dragMoveTime = new Date();
        this.dispatchEvent("dragMove", event, [
            pointer,
            moveVector
        ]);
    };
    proto.dragEnd = function(event, pointer) {
        if (!this.isDraggable) return;
        if (this.options.freeScroll) this.isFreeScrolling = true;
        // set selectedIndex based on where flick will end up
        var index = this.dragEndRestingSelect();
        if (this.options.freeScroll && !this.options.wrapAround) {
            // if free-scroll & not wrap around
            // do not free-scroll if going outside of bounding slides
            // so bounding slides can attract slider, and keep it in bounds
            var restingX = this.getRestingPosition();
            this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
        } else if (!this.options.freeScroll && index == this.selectedIndex) // boost selection if selected index has not changed
        index += this.dragEndBoostSelect();
        delete this.previousDragX;
        // apply selection
        // TODO refactor this, selecting here feels weird
        // HACK, set flag so dragging stays in correct direction
        this.isDragSelect = this.options.wrapAround;
        this.select(index);
        delete this.isDragSelect;
        this.dispatchEvent("dragEnd", event, [
            pointer
        ]);
    };
    proto.dragEndRestingSelect = function() {
        var restingX = this.getRestingPosition();
        // how far away from selected slide
        var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
        // get closet resting going up and going down
        var positiveResting = this._getClosestResting(restingX, distance, 1);
        var negativeResting = this._getClosestResting(restingX, distance, -1);
        // use closer resting for wrap-around
        var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
        return index;
    };
    /**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */ proto._getClosestResting = function(restingX, distance, increment) {
        var index = this.selectedIndex;
        var minDistance = Infinity;
        var condition = this.options.contain && !this.options.wrapAround ? // if contain, keep going if distance is equal to minDistance
        function(dist, minDist) {
            return dist <= minDist;
        } : function(dist, minDist) {
            return dist < minDist;
        };
        while(condition(distance, minDistance)){
            // measure distance to next cell
            index += increment;
            minDistance = distance;
            distance = this.getSlideDistance(-restingX, index);
            if (distance === null) break;
            distance = Math.abs(distance);
        }
        return {
            distance: minDistance,
            // selected was previous index
            index: index - increment
        };
    };
    /**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */ proto.getSlideDistance = function(x, index) {
        var len = this.slides.length;
        // wrap around if at least 2 slides
        var isWrapAround = this.options.wrapAround && len > 1;
        var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
        var slide = this.slides[slideIndex];
        if (!slide) return null;
        // add distance for wrap-around slides
        var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
        return x - (slide.target + wrap);
    };
    proto.dragEndBoostSelect = function() {
        // do not boost if no previousDragX or dragMoveTime
        if (this.previousDragX === undefined || !this.dragMoveTime || // or if drag was held for 100 ms
        new Date() - this.dragMoveTime > 100) return 0;
        var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
        var delta = this.previousDragX - this.dragX;
        if (distance > 0 && delta > 0) // boost to next if moving towards the right, and positive velocity
        return 1;
        else if (distance < 0 && delta < 0) // boost to previous if moving towards the left, and negative velocity
        return -1;
        return 0;
    };
    // ----- staticClick ----- //
    proto.staticClick = function(event, pointer) {
        // get clickedCell, if cell was clicked
        var clickedCell = this.getParentCell(event.target);
        var cellElem = clickedCell && clickedCell.element;
        var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
        this.dispatchEvent("staticClick", event, [
            pointer,
            cellElem,
            cellIndex
        ]);
    };
    // ----- scroll ----- //
    proto.onscroll = function() {
        var scroll = getScrollPosition();
        var scrollMoveX = this.pointerDownScroll.x - scroll.x;
        var scrollMoveY = this.pointerDownScroll.y - scroll.y;
        // cancel click/tap if scroll is too much
        if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) this._pointerDone();
    };
    // ----- utils ----- //
    function getScrollPosition() {
        return {
            x: window1.pageXOffset,
            y: window1.pageYOffset
        };
    }
    // -----  ----- //
    return Flickity;
});

});
parcelRequire.register("2Ao6B", function(module, exports) {

/*!
 * Unidragger v2.3.1
 * Draggable base class
 * MIT license
 */ /*jshint browser: true, unused: true, undef: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /*jshint strict: false */ /*globals define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "unipointer/unipointer"
    ], function(Unipointer) {
        return factory(window1, Unipointer);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("eAKIR")));
    else // browser global
    window1.Unidragger = factory(window1, window1.Unipointer);
})(window, function factory(window1, Unipointer) {
    "use strict";
    // -------------------------- Unidragger -------------------------- //
    function Unidragger() {}
    // inherit Unipointer & EvEmitter
    var proto = Unidragger.prototype = Object.create(Unipointer.prototype);
    // ----- bind start ----- //
    proto.bindHandles = function() {
        this._bindHandles(true);
    };
    proto.unbindHandles = function() {
        this._bindHandles(false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd
 */ proto._bindHandles = function(isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        // bind each handle
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        var touchAction = isAdd ? this._touchActionValue : "";
        for(var i = 0; i < this.handles.length; i++){
            var handle = this.handles[i];
            this._bindStartEvent(handle, isAdd);
            handle[bindMethod]("click", this);
            // touch-action: none to override browser touch gestures. metafizzy/flickity#540
            if (window1.PointerEvent) handle.style.touchAction = touchAction;
        }
    };
    // prototype so it can be overwriteable by Flickity
    proto._touchActionValue = "none";
    // ----- start event ----- //
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerDown = function(event, pointer) {
        var isOkay = this.okayPointerDown(event);
        if (!isOkay) return;
        // track start event position
        // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
        this.pointerDownPointer = {
            pageX: pointer.pageX,
            pageY: pointer.pageY
        };
        event.preventDefault();
        this.pointerDownBlur();
        // bind move and end events
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [
            event,
            pointer
        ]);
    };
    // nodes that have text fields
    var cursorNodes = {
        TEXTAREA: true,
        INPUT: true,
        SELECT: true,
        OPTION: true
    };
    // input types that do not have text fields
    var clickTypes = {
        radio: true,
        checkbox: true,
        button: true,
        submit: true,
        image: true,
        file: true
    };
    // dismiss inputs with text fields. flickity#403, flickity#404
    proto.okayPointerDown = function(event) {
        var isCursorNode = cursorNodes[event.target.nodeName];
        var isClickType = clickTypes[event.target.type];
        var isOkay = !isCursorNode || isClickType;
        if (!isOkay) this._pointerReset();
        return isOkay;
    };
    // kludge to blur previously focused input
    proto.pointerDownBlur = function() {
        var focused = document.activeElement;
        // do not blur body for IE10, metafizzy/flickity#117
        var canBlur = focused && focused.blur && focused != document.body;
        if (canBlur) focused.blur();
    };
    // ----- move event ----- //
    /**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerMove = function(event, pointer) {
        var moveVector = this._dragPointerMove(event, pointer);
        this.emitEvent("pointerMove", [
            event,
            pointer,
            moveVector
        ]);
        this._dragMove(event, pointer, moveVector);
    };
    // base pointer move logic
    proto._dragPointerMove = function(event, pointer) {
        var moveVector = {
            x: pointer.pageX - this.pointerDownPointer.pageX,
            y: pointer.pageY - this.pointerDownPointer.pageY
        };
        // start drag if pointer has moved far enough to start drag
        if (!this.isDragging && this.hasDragStarted(moveVector)) this._dragStart(event, pointer);
        return moveVector;
    };
    // condition if pointer has moved far enough to start drag
    proto.hasDragStarted = function(moveVector) {
        return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
    };
    // ----- end event ----- //
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto.pointerUp = function(event, pointer) {
        this.emitEvent("pointerUp", [
            event,
            pointer
        ]);
        this._dragPointerUp(event, pointer);
    };
    proto._dragPointerUp = function(event, pointer) {
        if (this.isDragging) this._dragEnd(event, pointer);
        else // pointer didn't move enough for drag to start
        this._staticClick(event, pointer);
    };
    // -------------------------- drag -------------------------- //
    // dragStart
    proto._dragStart = function(event, pointer) {
        this.isDragging = true;
        // prevent clicks
        this.isPreventingClicks = true;
        this.dragStart(event, pointer);
    };
    proto.dragStart = function(event, pointer) {
        this.emitEvent("dragStart", [
            event,
            pointer
        ]);
    };
    // dragMove
    proto._dragMove = function(event, pointer, moveVector) {
        // do not drag if not dragging yet
        if (!this.isDragging) return;
        this.dragMove(event, pointer, moveVector);
    };
    proto.dragMove = function(event, pointer, moveVector) {
        event.preventDefault();
        this.emitEvent("dragMove", [
            event,
            pointer,
            moveVector
        ]);
    };
    // dragEnd
    proto._dragEnd = function(event, pointer) {
        // set flags
        this.isDragging = false;
        // re-enable clicking async
        setTimeout((function() {
            delete this.isPreventingClicks;
        }).bind(this));
        this.dragEnd(event, pointer);
    };
    proto.dragEnd = function(event, pointer) {
        this.emitEvent("dragEnd", [
            event,
            pointer
        ]);
    };
    // ----- onclick ----- //
    // handle all clicks and prevent clicks when dragging
    proto.onclick = function(event) {
        if (this.isPreventingClicks) event.preventDefault();
    };
    // ----- staticClick ----- //
    // triggered after pointer down & up with no/tiny movement
    proto._staticClick = function(event, pointer) {
        // ignore emulated mouse up clicks
        if (this.isIgnoringMouseUp && event.type == "mouseup") return;
        this.staticClick(event, pointer);
        // set flag for emulated clicks 300ms after touchend
        if (event.type != "mouseup") {
            this.isIgnoringMouseUp = true;
            // reset flag after 300ms
            setTimeout((function() {
                delete this.isIgnoringMouseUp;
            }).bind(this), 400);
        }
    };
    proto.staticClick = function(event, pointer) {
        this.emitEvent("staticClick", [
            event,
            pointer
        ]);
    };
    // ----- utils ----- //
    Unidragger.getPointerPoint = Unipointer.getPointerPoint;
    // -----  ----- //
    return Unidragger;
});

});
parcelRequire.register("eAKIR", function(module, exports) {

/*!
 * Unipointer v2.3.0
 * base class for doing one thing with pointer event
 * MIT license
 */ /*jshint browser: true, undef: true, unused: true, strict: true */ (function(window1, factory) {
    // universal module definition
    /* jshint strict: false */ /*global define, module, require */ if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter"
    ], function(EvEmitter) {
        return factory(window1, EvEmitter);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("72Iw5")));
    else // browser global
    window1.Unipointer = factory(window1, window1.EvEmitter);
})(window, function factory(window1, EvEmitter) {
    "use strict";
    function noop() {}
    function Unipointer() {}
    // inherit EvEmitter
    var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
    proto.bindStartEvent = function(elem) {
        this._bindStartEvent(elem, true);
    };
    proto.unbindStartEvent = function(elem) {
        this._bindStartEvent(elem, false);
    };
    /**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */ proto._bindStartEvent = function(elem, isAdd) {
        // munge isAdd, default to true
        isAdd = isAdd === undefined ? true : isAdd;
        var bindMethod = isAdd ? "addEventListener" : "removeEventListener";
        // default to mouse events
        var startEvent = "mousedown";
        if (window1.PointerEvent) // Pointer Events
        startEvent = "pointerdown";
        else if ("ontouchstart" in window1) // Touch Events. iOS Safari
        startEvent = "touchstart";
        elem[bindMethod](startEvent, this);
    };
    // trigger handler methods for events
    proto.handleEvent = function(event) {
        var method = "on" + event.type;
        if (this[method]) this[method](event);
    };
    // returns the touch that we're keeping track of
    proto.getTouch = function(touches) {
        for(var i = 0; i < touches.length; i++){
            var touch = touches[i];
            if (touch.identifier == this.pointerIdentifier) return touch;
        }
    };
    // ----- start event ----- //
    proto.onmousedown = function(event) {
        // dismiss clicks from right or middle buttons
        var button = event.button;
        if (button && button !== 0 && button !== 1) return;
        this._pointerDown(event, event);
    };
    proto.ontouchstart = function(event) {
        this._pointerDown(event, event.changedTouches[0]);
    };
    proto.onpointerdown = function(event) {
        this._pointerDown(event, event);
    };
    /**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */ proto._pointerDown = function(event, pointer) {
        // dismiss right click and other pointers
        // button = 0 is okay, 1-4 not
        if (event.button || this.isPointerDown) return;
        this.isPointerDown = true;
        // save pointer identifier to match up touch events
        this.pointerIdentifier = pointer.pointerId !== undefined ? // pointerId for pointer events, touch.indentifier for touch events
        pointer.pointerId : pointer.identifier;
        this.pointerDown(event, pointer);
    };
    proto.pointerDown = function(event, pointer) {
        this._bindPostStartEvents(event);
        this.emitEvent("pointerDown", [
            event,
            pointer
        ]);
    };
    // hash of events to be bound after start event
    var postStartEvents = {
        mousedown: [
            "mousemove",
            "mouseup"
        ],
        touchstart: [
            "touchmove",
            "touchend",
            "touchcancel"
        ],
        pointerdown: [
            "pointermove",
            "pointerup",
            "pointercancel"
        ]
    };
    proto._bindPostStartEvents = function(event) {
        if (!event) return;
        // get proper events to match start event
        var events = postStartEvents[event.type];
        // bind events to node
        events.forEach(function(eventName) {
            window1.addEventListener(eventName, this);
        }, this);
        // save these arguments
        this._boundPointerEvents = events;
    };
    proto._unbindPostStartEvents = function() {
        // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
        if (!this._boundPointerEvents) return;
        this._boundPointerEvents.forEach(function(eventName) {
            window1.removeEventListener(eventName, this);
        }, this);
        delete this._boundPointerEvents;
    };
    // ----- move event ----- //
    proto.onmousemove = function(event) {
        this._pointerMove(event, event);
    };
    proto.onpointermove = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerMove(event, event);
    };
    proto.ontouchmove = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerMove(event, touch);
    };
    /**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerMove = function(event, pointer) {
        this.pointerMove(event, pointer);
    };
    // public
    proto.pointerMove = function(event, pointer) {
        this.emitEvent("pointerMove", [
            event,
            pointer
        ]);
    };
    // ----- end event ----- //
    proto.onmouseup = function(event) {
        this._pointerUp(event, event);
    };
    proto.onpointerup = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerUp(event, event);
    };
    proto.ontouchend = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerUp(event, touch);
    };
    /**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerUp = function(event, pointer) {
        this._pointerDone();
        this.pointerUp(event, pointer);
    };
    // public
    proto.pointerUp = function(event, pointer) {
        this.emitEvent("pointerUp", [
            event,
            pointer
        ]);
    };
    // ----- pointer done ----- //
    // triggered on pointer up & pointer cancel
    proto._pointerDone = function() {
        this._pointerReset();
        this._unbindPostStartEvents();
        this.pointerDone();
    };
    proto._pointerReset = function() {
        // reset properties
        this.isPointerDown = false;
        delete this.pointerIdentifier;
    };
    proto.pointerDone = noop;
    // ----- pointer cancel ----- //
    proto.onpointercancel = function(event) {
        if (event.pointerId == this.pointerIdentifier) this._pointerCancel(event, event);
    };
    proto.ontouchcancel = function(event) {
        var touch = this.getTouch(event.changedTouches);
        if (touch) this._pointerCancel(event, touch);
    };
    /**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */ proto._pointerCancel = function(event, pointer) {
        this._pointerDone();
        this.pointerCancel(event, pointer);
    };
    // public
    proto.pointerCancel = function(event, pointer) {
        this.emitEvent("pointerCancel", [
            event,
            pointer
        ]);
    };
    // -----  ----- //
    // utility function for getting x/y coords from event
    Unipointer.getPointerPoint = function(pointer) {
        return {
            x: pointer.pageX,
            y: pointer.pageY
        };
    };
    // -----  ----- //
    return Unipointer;
});

});



parcelRequire.register("bEazz", function(module, exports) {



// prev/next buttons
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unipointer/unipointer",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("g0Txk")), (parcelRequire("eAKIR")), (parcelRequire("8bpzM")));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    "use strict";
    var svgURI = "http://www.w3.org/2000/svg";
    // -------------------------- PrevNextButton -------------------------- //
    function PrevNextButton(direction, parent) {
        this.direction = direction;
        this.parent = parent;
        this._create();
    }
    PrevNextButton.prototype = Object.create(Unipointer.prototype);
    PrevNextButton.prototype._create = function() {
        // properties
        this.isEnabled = true;
        this.isPrevious = this.direction == -1;
        var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
        this.isLeft = this.direction == leftDirection;
        var element = this.element = document.createElement("button");
        element.className = "flickity-button flickity-prev-next-button";
        element.className += this.isPrevious ? " previous" : " next";
        // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
        element.setAttribute("type", "button");
        // init as disabled
        this.disable();
        element.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
        // create arrow
        var svg = this.createSVG();
        element.appendChild(svg);
        // events
        this.parent.on("select", this.update.bind(this));
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PrevNextButton.prototype.activate = function() {
        this.bindStartEvent(this.element);
        this.element.addEventListener("click", this);
        // add to DOM
        this.parent.element.appendChild(this.element);
    };
    PrevNextButton.prototype.deactivate = function() {
        // remove from DOM
        this.parent.element.removeChild(this.element);
        // click events
        this.unbindStartEvent(this.element);
        this.element.removeEventListener("click", this);
    };
    PrevNextButton.prototype.createSVG = function() {
        var svg = document.createElementNS(svgURI, "svg");
        svg.setAttribute("class", "flickity-button-icon");
        svg.setAttribute("viewBox", "0 0 100 100");
        var path = document.createElementNS(svgURI, "path");
        var pathMovements = getArrowMovements(this.parent.options.arrowShape);
        path.setAttribute("d", pathMovements);
        path.setAttribute("class", "arrow");
        // rotate arrow
        if (!this.isLeft) path.setAttribute("transform", "translate(100, 100) rotate(180) ");
        svg.appendChild(path);
        return svg;
    };
    // get SVG path movmement
    function getArrowMovements(shape) {
        // use shape as movement if string
        if (typeof shape == "string") return shape;
        // create movement string
        return "M " + shape.x0 + ",50" + " L " + shape.x1 + "," + (shape.y1 + 50) + " L " + shape.x2 + "," + (shape.y2 + 50) + " L " + shape.x3 + ",50 " + " L " + shape.x2 + "," + (50 - shape.y2) + " L " + shape.x1 + "," + (50 - shape.y1) + " Z";
    }
    PrevNextButton.prototype.handleEvent = utils.handleEvent;
    PrevNextButton.prototype.onclick = function() {
        if (!this.isEnabled) return;
        this.parent.uiChange();
        var method = this.isPrevious ? "previous" : "next";
        this.parent[method]();
    };
    // -----  ----- //
    PrevNextButton.prototype.enable = function() {
        if (this.isEnabled) return;
        this.element.disabled = false;
        this.isEnabled = true;
    };
    PrevNextButton.prototype.disable = function() {
        if (!this.isEnabled) return;
        this.element.disabled = true;
        this.isEnabled = false;
    };
    PrevNextButton.prototype.update = function() {
        // index of first or last slide, if previous or next
        var slides = this.parent.slides;
        // enable is wrapAround and at least 2 slides
        if (this.parent.options.wrapAround && slides.length > 1) {
            this.enable();
            return;
        }
        var lastIndex = slides.length ? slides.length - 1 : 0;
        var boundIndex = this.isPrevious ? 0 : lastIndex;
        var method = this.parent.selectedIndex == boundIndex ? "disable" : "enable";
        this[method]();
    };
    PrevNextButton.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    // -------------------------- Flickity prototype -------------------------- //
    utils.extend(Flickity.defaults, {
        prevNextButtons: true,
        arrowShape: {
            x0: 10,
            x1: 60,
            y1: 50,
            x2: 70,
            y2: 40,
            x3: 30
        }
    });
    Flickity.createMethods.push("_createPrevNextButtons");
    var proto = Flickity.prototype;
    proto._createPrevNextButtons = function() {
        if (!this.options.prevNextButtons) return;
        this.prevButton = new PrevNextButton(-1, this);
        this.nextButton = new PrevNextButton(1, this);
        this.on("activate", this.activatePrevNextButtons);
    };
    proto.activatePrevNextButtons = function() {
        this.prevButton.activate();
        this.nextButton.activate();
        this.on("deactivate", this.deactivatePrevNextButtons);
    };
    proto.deactivatePrevNextButtons = function() {
        this.prevButton.deactivate();
        this.nextButton.deactivate();
        this.off("deactivate", this.deactivatePrevNextButtons);
    };
    // --------------------------  -------------------------- //
    Flickity.PrevNextButton = PrevNextButton;
    return Flickity;
});

});

parcelRequire.register("gheIK", function(module, exports) {



// page dots
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "unipointer/unipointer",
        "fizzy-ui-utils/utils"
    ], function(Flickity, Unipointer, utils) {
        return factory(window1, Flickity, Unipointer, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("g0Txk")), (parcelRequire("eAKIR")), (parcelRequire("8bpzM")));
    else // browser global
    factory(window1, window1.Flickity, window1.Unipointer, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, Unipointer, utils) {
    // -------------------------- PageDots -------------------------- //
    "use strict";
    function PageDots(parent) {
        this.parent = parent;
        this._create();
    }
    PageDots.prototype = Object.create(Unipointer.prototype);
    PageDots.prototype._create = function() {
        // create holder element
        this.holder = document.createElement("ol");
        this.holder.className = "flickity-page-dots";
        // create dots, array of elements
        this.dots = [];
        // events
        this.handleClick = this.onClick.bind(this);
        this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
    };
    PageDots.prototype.activate = function() {
        this.setDots();
        this.holder.addEventListener("click", this.handleClick);
        this.bindStartEvent(this.holder);
        // add to DOM
        this.parent.element.appendChild(this.holder);
    };
    PageDots.prototype.deactivate = function() {
        this.holder.removeEventListener("click", this.handleClick);
        this.unbindStartEvent(this.holder);
        // remove from DOM
        this.parent.element.removeChild(this.holder);
    };
    PageDots.prototype.setDots = function() {
        // get difference between number of slides and number of dots
        var delta = this.parent.slides.length - this.dots.length;
        if (delta > 0) this.addDots(delta);
        else if (delta < 0) this.removeDots(-delta);
    };
    PageDots.prototype.addDots = function(count) {
        var fragment = document.createDocumentFragment();
        var newDots = [];
        var length = this.dots.length;
        var max = length + count;
        for(var i = length; i < max; i++){
            var dot = document.createElement("li");
            dot.className = "dot";
            dot.setAttribute("aria-label", "Page dot " + (i + 1));
            fragment.appendChild(dot);
            newDots.push(dot);
        }
        this.holder.appendChild(fragment);
        this.dots = this.dots.concat(newDots);
    };
    PageDots.prototype.removeDots = function(count) {
        // remove from this.dots collection
        var removeDots = this.dots.splice(this.dots.length - count, count);
        // remove from DOM
        removeDots.forEach(function(dot) {
            this.holder.removeChild(dot);
        }, this);
    };
    PageDots.prototype.updateSelected = function() {
        // remove selected class on previous
        if (this.selectedDot) {
            this.selectedDot.className = "dot";
            this.selectedDot.removeAttribute("aria-current");
        }
        // don't proceed if no dots
        if (!this.dots.length) return;
        this.selectedDot = this.dots[this.parent.selectedIndex];
        this.selectedDot.className = "dot is-selected";
        this.selectedDot.setAttribute("aria-current", "step");
    };
    PageDots.prototype.onTap = PageDots.prototype.onClick = function(event) {
        var target = event.target;
        // only care about dot clicks
        if (target.nodeName != "LI") return;
        this.parent.uiChange();
        var index = this.dots.indexOf(target);
        this.parent.select(index);
    };
    PageDots.prototype.destroy = function() {
        this.deactivate();
        this.allOff();
    };
    Flickity.PageDots = PageDots;
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pageDots: true
    });
    Flickity.createMethods.push("_createPageDots");
    var proto = Flickity.prototype;
    proto._createPageDots = function() {
        if (!this.options.pageDots) return;
        this.pageDots = new PageDots(this);
        // events
        this.on("activate", this.activatePageDots);
        this.on("select", this.updateSelectedPageDots);
        this.on("cellChange", this.updatePageDots);
        this.on("resize", this.updatePageDots);
        this.on("deactivate", this.deactivatePageDots);
    };
    proto.activatePageDots = function() {
        this.pageDots.activate();
    };
    proto.updateSelectedPageDots = function() {
        this.pageDots.updateSelected();
    };
    proto.updatePageDots = function() {
        this.pageDots.setDots();
    };
    proto.deactivatePageDots = function() {
        this.pageDots.deactivate();
    };
    // -----  ----- //
    Flickity.PageDots = PageDots;
    return Flickity;
});

});

parcelRequire.register("4H331", function(module, exports) {



// player & autoPlay
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "ev-emitter/ev-emitter",
        "fizzy-ui-utils/utils",
        "./flickity"
    ], function(EvEmitter, utils, Flickity) {
        return factory(EvEmitter, utils, Flickity);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory((parcelRequire("72Iw5")), (parcelRequire("8bpzM")), (parcelRequire("g0Txk")));
    else // browser global
    factory(window1.EvEmitter, window1.fizzyUIUtils, window1.Flickity);
})(window, function factory(EvEmitter, utils, Flickity) {
    "use strict";
    // -------------------------- Player -------------------------- //
    function Player(parent) {
        this.parent = parent;
        this.state = "stopped";
        // visibility change event handler
        this.onVisibilityChange = this.visibilityChange.bind(this);
        this.onVisibilityPlay = this.visibilityPlay.bind(this);
    }
    Player.prototype = Object.create(EvEmitter.prototype);
    // start play
    Player.prototype.play = function() {
        if (this.state == "playing") return;
        // do not play if page is hidden, start playing when page is visible
        var isPageHidden = document.hidden;
        if (isPageHidden) {
            document.addEventListener("visibilitychange", this.onVisibilityPlay);
            return;
        }
        this.state = "playing";
        // listen to visibility change
        document.addEventListener("visibilitychange", this.onVisibilityChange);
        // start ticking
        this.tick();
    };
    Player.prototype.tick = function() {
        // do not tick if not playing
        if (this.state != "playing") return;
        var time = this.parent.options.autoPlay;
        // default to 3 seconds
        time = typeof time == "number" ? time : 3000;
        var _this = this;
        // HACK: reset ticks if stopped and started within interval
        this.clear();
        this.timeout = setTimeout(function() {
            _this.parent.next(true);
            _this.tick();
        }, time);
    };
    Player.prototype.stop = function() {
        this.state = "stopped";
        this.clear();
        // remove visibility change event
        document.removeEventListener("visibilitychange", this.onVisibilityChange);
    };
    Player.prototype.clear = function() {
        clearTimeout(this.timeout);
    };
    Player.prototype.pause = function() {
        if (this.state == "playing") {
            this.state = "paused";
            this.clear();
        }
    };
    Player.prototype.unpause = function() {
        // re-start play if paused
        if (this.state == "paused") this.play();
    };
    // pause if page visibility is hidden, unpause if visible
    Player.prototype.visibilityChange = function() {
        var isPageHidden = document.hidden;
        this[isPageHidden ? "pause" : "unpause"]();
    };
    Player.prototype.visibilityPlay = function() {
        this.play();
        document.removeEventListener("visibilitychange", this.onVisibilityPlay);
    };
    // -------------------------- Flickity -------------------------- //
    utils.extend(Flickity.defaults, {
        pauseAutoPlayOnHover: true
    });
    Flickity.createMethods.push("_createPlayer");
    var proto = Flickity.prototype;
    proto._createPlayer = function() {
        this.player = new Player(this);
        this.on("activate", this.activatePlayer);
        this.on("uiChange", this.stopPlayer);
        this.on("pointerDown", this.stopPlayer);
        this.on("deactivate", this.deactivatePlayer);
    };
    proto.activatePlayer = function() {
        if (!this.options.autoPlay) return;
        this.player.play();
        this.element.addEventListener("mouseenter", this);
    };
    // Player API, don't hate the ... thanks I know where the door is
    proto.playPlayer = function() {
        this.player.play();
    };
    proto.stopPlayer = function() {
        this.player.stop();
    };
    proto.pausePlayer = function() {
        this.player.pause();
    };
    proto.unpausePlayer = function() {
        this.player.unpause();
    };
    proto.deactivatePlayer = function() {
        this.player.stop();
        this.element.removeEventListener("mouseenter", this);
    };
    // ----- mouseenter/leave ----- //
    // pause auto-play on hover
    proto.onmouseenter = function() {
        if (!this.options.pauseAutoPlayOnHover) return;
        this.player.pause();
        this.element.addEventListener("mouseleave", this);
    };
    // resume auto-play on hover off
    proto.onmouseleave = function() {
        this.player.unpause();
        this.element.removeEventListener("mouseleave", this);
    };
    // -----  ----- //
    Flickity.Player = Player;
    return Flickity;
});

});

parcelRequire.register("ertaa", function(module, exports) {


// add, remove cell
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "fizzy-ui-utils/utils"
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("g0Txk")), (parcelRequire("8bpzM")));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    "use strict";
    // append cells to a document fragment
    function getCellsFragment(cells) {
        var fragment = document.createDocumentFragment();
        cells.forEach(function(cell) {
            fragment.appendChild(cell.element);
        });
        return fragment;
    }
    // -------------------------- add/remove cell prototype -------------------------- //
    var proto = Flickity.prototype;
    /**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */ proto.insert = function(elems, index) {
        var cells = this._makeCells(elems);
        if (!cells || !cells.length) return;
        var len = this.cells.length;
        // default to append
        index = index === undefined ? len : index;
        // add cells with document fragment
        var fragment = getCellsFragment(cells);
        // append to slider
        var isAppend = index == len;
        if (isAppend) this.slider.appendChild(fragment);
        else {
            var insertCellElement = this.cells[index].element;
            this.slider.insertBefore(fragment, insertCellElement);
        }
        // add to this.cells
        if (index === 0) // prepend, add to start
        this.cells = cells.concat(this.cells);
        else if (isAppend) // append, add to end
        this.cells = this.cells.concat(cells);
        else {
            // insert in this.cells
            var endCells = this.cells.splice(index, len - index);
            this.cells = this.cells.concat(cells).concat(endCells);
        }
        this._sizeCells(cells);
        this.cellChange(index, true);
    };
    proto.append = function(elems) {
        this.insert(elems, this.cells.length);
    };
    proto.prepend = function(elems) {
        this.insert(elems, 0);
    };
    /**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */ proto.remove = function(elems) {
        var cells = this.getCells(elems);
        if (!cells || !cells.length) return;
        var minCellIndex = this.cells.length - 1;
        // remove cells from collection & DOM
        cells.forEach(function(cell) {
            cell.remove();
            var index = this.cells.indexOf(cell);
            minCellIndex = Math.min(index, minCellIndex);
            utils.removeFrom(this.cells, cell);
        }, this);
        this.cellChange(minCellIndex, true);
    };
    /**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */ proto.cellSizeChange = function(elem) {
        var cell = this.getCell(elem);
        if (!cell) return;
        cell.getSize();
        var index = this.cells.indexOf(cell);
        this.cellChange(index);
    };
    /**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */ proto.cellChange = function(changedCellIndex, isPositioningSlider) {
        var prevSelectedElem = this.selectedElement;
        this._positionCells(changedCellIndex);
        this._getWrapShiftCells();
        this.setGallerySize();
        // update selectedIndex
        // try to maintain position & select previous selected element
        var cell = this.getCell(prevSelectedElem);
        if (cell) this.selectedIndex = this.getCellSlideIndex(cell);
        this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
        this.emitEvent("cellChange", [
            changedCellIndex
        ]);
        // position slider
        this.select(this.selectedIndex);
        // do not position slider after lazy load
        if (isPositioningSlider) this.positionSliderAtSelected();
    };
    // -----  ----- //
    return Flickity;
});

});

parcelRequire.register("28ytO", function(module, exports) {


// lazyload
(function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "fizzy-ui-utils/utils"
    ], function(Flickity, utils) {
        return factory(window1, Flickity, utils);
    });
    else if (0, module.exports) // CommonJS
    module.exports = factory(window1, (parcelRequire("g0Txk")), (parcelRequire("8bpzM")));
    else // browser global
    factory(window1, window1.Flickity, window1.fizzyUIUtils);
})(window, function factory(window1, Flickity, utils) {
    "use strict";
    Flickity.createMethods.push("_createLazyload");
    var proto = Flickity.prototype;
    proto._createLazyload = function() {
        this.on("select", this.lazyLoad);
    };
    proto.lazyLoad = function() {
        var lazyLoad = this.options.lazyLoad;
        if (!lazyLoad) return;
        // get adjacent cells, use lazyLoad option for adjacent count
        var adjCount = typeof lazyLoad == "number" ? lazyLoad : 0;
        var cellElems = this.getAdjacentCellElements(adjCount);
        // get lazy images in those cells
        var lazyImages = [];
        cellElems.forEach(function(cellElem) {
            var lazyCellImages = getCellLazyImages(cellElem);
            lazyImages = lazyImages.concat(lazyCellImages);
        });
        // load lazy images
        lazyImages.forEach(function(img) {
            new LazyLoader(img, this);
        }, this);
    };
    function getCellLazyImages(cellElem) {
        // check if cell element is lazy image
        if (cellElem.nodeName == "IMG") {
            var lazyloadAttr = cellElem.getAttribute("data-flickity-lazyload");
            var srcAttr = cellElem.getAttribute("data-flickity-lazyload-src");
            var srcsetAttr = cellElem.getAttribute("data-flickity-lazyload-srcset");
            if (lazyloadAttr || srcAttr || srcsetAttr) return [
                cellElem
            ];
        }
        // select lazy images in cell
        var lazySelector = "img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]";
        var imgs = cellElem.querySelectorAll(lazySelector);
        return utils.makeArray(imgs);
    }
    // -------------------------- LazyLoader -------------------------- //
    /**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */ function LazyLoader(img, flickity) {
        this.img = img;
        this.flickity = flickity;
        this.load();
    }
    LazyLoader.prototype.handleEvent = utils.handleEvent;
    LazyLoader.prototype.load = function() {
        this.img.addEventListener("load", this);
        this.img.addEventListener("error", this);
        // get src & srcset
        var src = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src");
        var srcset = this.img.getAttribute("data-flickity-lazyload-srcset");
        // set src & serset
        this.img.src = src;
        if (srcset) this.img.setAttribute("srcset", srcset);
        // remove attr
        this.img.removeAttribute("data-flickity-lazyload");
        this.img.removeAttribute("data-flickity-lazyload-src");
        this.img.removeAttribute("data-flickity-lazyload-srcset");
    };
    LazyLoader.prototype.onload = function(event) {
        this.complete(event, "flickity-lazyloaded");
    };
    LazyLoader.prototype.onerror = function(event) {
        this.complete(event, "flickity-lazyerror");
    };
    LazyLoader.prototype.complete = function(event, className) {
        // unbind events
        this.img.removeEventListener("load", this);
        this.img.removeEventListener("error", this);
        var cell = this.flickity.getParentCell(this.img);
        var cellElem = cell && cell.element;
        this.flickity.cellSizeChange(cellElem);
        this.img.classList.add(className);
        this.flickity.dispatchEvent("lazyLoad", event, cellElem);
    };
    // -----  ----- //
    Flickity.LazyLoader = LazyLoader;
    return Flickity;
});

});

parcelRequire.register("1DJsI", function(module, exports) {

var $Jm0Yx = parcelRequire("Jm0Yx");
var $131cb2cf5f9464a2$var$hasWindow = typeof window !== "undefined";
function $131cb2cf5f9464a2$var$createScheduler() {
    var scheduler;
    if ($131cb2cf5f9464a2$var$hasWindow) {
        if (!window._nanoScheduler) window._nanoScheduler = new $131cb2cf5f9464a2$var$NanoScheduler(true);
        scheduler = window._nanoScheduler;
    } else scheduler = new $131cb2cf5f9464a2$var$NanoScheduler();
    return scheduler;
}
function $131cb2cf5f9464a2$var$NanoScheduler(hasWindow) {
    this.hasWindow = hasWindow;
    this.hasIdle = this.hasWindow && window.requestIdleCallback;
    this.method = this.hasIdle ? window.requestIdleCallback.bind(window) : this.setTimeout;
    this.scheduled = false;
    this.queue = [];
}
$131cb2cf5f9464a2$var$NanoScheduler.prototype.push = function(cb) {
    $Jm0Yx.equal(typeof cb, "function", "nanoscheduler.push: cb should be type function");
    this.queue.push(cb);
    this.schedule();
};
$131cb2cf5f9464a2$var$NanoScheduler.prototype.schedule = function() {
    if (this.scheduled) return;
    this.scheduled = true;
    var self = this;
    this.method(function(idleDeadline) {
        var cb;
        while(self.queue.length && idleDeadline.timeRemaining() > 0){
            cb = self.queue.shift();
            cb(idleDeadline);
        }
        self.scheduled = false;
        if (self.queue.length) self.schedule();
    });
};
$131cb2cf5f9464a2$var$NanoScheduler.prototype.setTimeout = function(cb) {
    setTimeout(cb, 0, {
        timeRemaining: function() {
            return 1;
        }
    });
};
module.exports = $131cb2cf5f9464a2$var$createScheduler;

});
parcelRequire.register("Jm0Yx", function(module, exports) {
$088547c056753fbd$var$assert.notEqual = $088547c056753fbd$var$notEqual;
$088547c056753fbd$var$assert.notOk = $088547c056753fbd$var$notOk;
$088547c056753fbd$var$assert.equal = $088547c056753fbd$var$equal;
$088547c056753fbd$var$assert.ok = $088547c056753fbd$var$assert;
module.exports = $088547c056753fbd$var$assert;
function $088547c056753fbd$var$equal(a, b, m) {
    $088547c056753fbd$var$assert(a == b, m) // eslint-disable-line eqeqeq
    ;
}
function $088547c056753fbd$var$notEqual(a, b, m) {
    $088547c056753fbd$var$assert(a != b, m) // eslint-disable-line eqeqeq
    ;
}
function $088547c056753fbd$var$notOk(t, m) {
    $088547c056753fbd$var$assert(!t, m);
}
function $088547c056753fbd$var$assert(t, m) {
    if (!t) throw new Error(m || "AssertionError");
}

});


/**
 * Functionality
 */ // Listens for a Tab key press. If deteced 'tabbing' class is added
// to the html element and the listener is removed.
function $65b4de7ca7b2ca88$export$2e2bcd8739ae039() {
    const onKeyUp = function(e) {
        const charCode = e.which || e.keyCode;
        if (charCode === 9) {
            document.documentElement.classList.add("tabbing");
            document.removeEventListener("keyup", onKeyUp);
        }
    };
    document.addEventListener("keyup", onKeyUp);
}


var $f31978d9b51db8d6$exports = {};
var $842ae172950db755$exports = {};
var $842ae172950db755$var$DOCUMENT_NODE_TYPE = 9;
/**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
    var $842ae172950db755$var$proto = Element.prototype;
    $842ae172950db755$var$proto.matches = $842ae172950db755$var$proto.matchesSelector || $842ae172950db755$var$proto.mozMatchesSelector || $842ae172950db755$var$proto.msMatchesSelector || $842ae172950db755$var$proto.oMatchesSelector || $842ae172950db755$var$proto.webkitMatchesSelector;
}
/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function $842ae172950db755$var$closest(element, selector) {
    while(element && element.nodeType !== $842ae172950db755$var$DOCUMENT_NODE_TYPE){
        if (typeof element.matches === "function" && element.matches(selector)) return element;
        element = element.parentNode;
    }
}
$842ae172950db755$exports = $842ae172950db755$var$closest;


/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function $f31978d9b51db8d6$var$_delegate(element, selector, type, callback, useCapture) {
    var listenerFn = $f31978d9b51db8d6$var$listener.apply(this, arguments);
    element.addEventListener(type, listenerFn, useCapture);
    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    };
}
/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function $f31978d9b51db8d6$var$delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === "function") return $f31978d9b51db8d6$var$_delegate.apply(null, arguments);
    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
    // This is a short way to .unshift `arguments` without running into deoptimizations
    return $f31978d9b51db8d6$var$_delegate.bind(null, document).apply(null, arguments);
    // Handle Selector-based usage
    if (typeof elements === "string") elements = document.querySelectorAll(elements);
    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function(element) {
        return $f31978d9b51db8d6$var$_delegate(element, selector, type, callback, useCapture);
    });
}
/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function $f31978d9b51db8d6$var$listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = $842ae172950db755$exports(e.target, selector);
        if (e.delegateTarget) callback.call(element, e);
    };
}
$f31978d9b51db8d6$exports = $f31978d9b51db8d6$var$delegate;


function $0bbedd1cf2657f4d$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))(document.body, "a[href]", "click", (e)=>{
        var a = new RegExp("/" + window.location.host + "/|mailto:");
        if (!a.test(e.delegateTarget.href)) {
            e.preventDefault();
            e.stopPropagation();
            window.open(e.delegateTarget.href, "_blank");
        }
    });
}



function $0ffb30c7ca5554ae$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))("[data-sublink]", "click", (e)=>{
        const a = e.delegateTarget.querySelector("a");
        if (a && e.target !== a) {
            a.click();
            return;
        }
        const btn = e.delegateTarget.querySelector("button");
        if (btn && e.target !== btn) {
            btn.click();
            return;
        }
    }, false);
}



function $ad4b2b72846e4da5$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))('a[href^="#"]', "click", (e)=>{
        e.preventDefault();
        const $section = document.querySelector(e.target.hash);
        if ($section) window.scroll({
            top: $section.offsetTop,
            behavior: "smooth"
        });
    }, false);
}


var $93307c02d3900b6f$exports = {};
(function(global, factory) {
    $93307c02d3900b6f$exports = factory();
})($93307c02d3900b6f$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */ var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    // don't know a better way to get the size of a CSS 100vh…
    function createTestElement() {
        var testElement = document.createElement("div");
        testElement.style.cssText = "position: fixed; top: 0; height: 100vh; pointer-events: none;";
        document.documentElement.insertBefore(testElement, document.documentElement.firstChild);
        return testElement;
    }
    function removeTestElement(element) {
        document.documentElement.removeChild(element);
    }
    //  in some browsers this will be bigger than window.innerHeight
    function checkSizes() {
        var vhTest = createTestElement();
        var windowHeight = window.innerHeight;
        var vh = vhTest.offsetHeight;
        var offset = vh - windowHeight;
        removeTestElement(vhTest);
        return {
            vh: vh,
            windowHeight: windowHeight,
            offset: offset,
            isNeeded: offset !== 0,
            value: 0
        };
    }
    // export
    function noop() {}
    function computeDifference() {
        var sizes = checkSizes();
        sizes.value = sizes.offset;
        return sizes;
    }
    function redefineVhUnit() {
        var sizes = checkSizes();
        sizes.value = sizes.windowHeight * 0.01;
        return sizes;
    }
    var methods = /*#__PURE__*/ Object.freeze({
        noop: noop,
        computeDifference: computeDifference,
        redefineVhUnit: redefineVhUnit
    });
    function isString(text) {
        return typeof text === "string" && text.length > 0;
    }
    function isFunction(f) {
        return typeof f === "function";
    }
    var defaultOptions = Object.freeze({
        cssVarName: "vh-offset",
        redefineVh: false,
        method: computeDifference,
        force: false,
        bind: true,
        updateOnTouch: false,
        onUpdate: noop
    });
    function getOptions(options) {
        // old options handling: only redefine the CSS var name
        if (isString(options)) return __assign({}, defaultOptions, {
            cssVarName: options
        });
        // be sure to have a configuration object
        if (typeof options !== "object") return defaultOptions;
        // make sure we have the right options to start with
        var finalOptions = {
            force: options.force === true,
            bind: options.bind !== false,
            updateOnTouch: options.updateOnTouch === true,
            onUpdate: isFunction(options.onUpdate) ? options.onUpdate : noop
        };
        // method change
        var redefineVh = options.redefineVh === true;
        finalOptions.method = methods[redefineVh ? "redefineVhUnit" : "computeDifference"];
        finalOptions.cssVarName = isString(options.cssVarName) ? options.cssVarName : redefineVh ? /*
                  when redefining vh unit we follow this article name convention
                  https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
                */ "vh" : defaultOptions.cssVarName;
        return finalOptions;
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    var passiveSupported = false;
    var eventListeners = [];
    /* istanbul ignore next */ try {
        var options = Object.defineProperty({}, "passive", {
            get: function() {
                passiveSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (err) {
        passiveSupported = false;
    }
    function addListener(eventName, callback) {
        eventListeners.push({
            eventName: eventName,
            callback: callback
        });
        window.addEventListener(eventName, callback, /* istanbul ignore next */ passiveSupported ? {
            passive: true
        } : false);
    }
    function removeAll() {
        eventListeners.forEach(function(config) {
            window.removeEventListener(config.eventName, config.callback);
        });
        eventListeners = [];
    }
    function updateCssVar(cssVarName, result) {
        document.documentElement.style.setProperty("--" + cssVarName, result.value + "px");
    }
    function formatResult(sizes, options) {
        return __assign({}, sizes, {
            unbind: removeAll,
            recompute: options.method
        });
    }
    function vhCheck(options) {
        var config = Object.freeze(getOptions(options));
        var result = formatResult(config.method(), config);
        // usefulness check
        if (!result.isNeeded && !config.force) return result;
        updateCssVar(config.cssVarName, result);
        config.onUpdate(result);
        // enabled by default
        if (!config.bind) return result;
        function onWindowChange() {
            window.requestAnimationFrame(function() {
                var sizes = config.method();
                updateCssVar(config.cssVarName, sizes);
                config.onUpdate(formatResult(sizes, config));
            });
        }
        // be sure we don't duplicates events listeners
        result.unbind();
        // listen for orientation change
        // - this can't be configured
        // - because it's convenient and not a real performance bottleneck
        addListener("orientationchange", onWindowChange);
        // listen to touch move for scrolling
        // – disabled by default
        // - listening to scrolling can be expansive…
        if (config.updateOnTouch) addListener("touchmove", onWindowChange);
        return result;
    }
    return vhCheck;
});


var $cee2a9123a7e8ef2$export$2e2bcd8739ae039 = typeof Promise === "function" ? Promise : function(fn) {
    let queue = [], resolved = 0, value;
    fn(($)=>{
        value = $;
        resolved = 1;
        queue.splice(0).forEach(then);
    });
    return {
        then: then
    };
    function then(fn) {
        return resolved ? setTimeout(fn, 0, value) : queue.push(fn), this;
    }
};


const $52ca24f3afc1ec72$var$TRUE = true, $52ca24f3afc1ec72$var$FALSE = false;
const $52ca24f3afc1ec72$var$QSA = "querySelectorAll";
function $52ca24f3afc1ec72$var$add(node) {
    this.observe(node, {
        subtree: $52ca24f3afc1ec72$var$TRUE,
        childList: $52ca24f3afc1ec72$var$TRUE
    });
}
const $52ca24f3afc1ec72$export$5e14cdade93d6f7b = (callback, root, MO)=>{
    const loop = (nodes, added, removed, connected, pass)=>{
        for(let i = 0, { length: length } = nodes; i < length; i++){
            const node = nodes[i];
            if (pass || $52ca24f3afc1ec72$var$QSA in node) {
                if (connected) {
                    if (!added.has(node)) {
                        added.add(node);
                        removed.delete(node);
                        callback(node, connected);
                    }
                } else if (!removed.has(node)) {
                    removed.add(node);
                    added.delete(node);
                    callback(node, connected);
                }
                if (!pass) loop(node[$52ca24f3afc1ec72$var$QSA]("*"), added, removed, connected, $52ca24f3afc1ec72$var$TRUE);
            }
        }
    };
    const observer = new (MO || MutationObserver)((records)=>{
        for(let added = new Set, removed = new Set, i = 0, { length: length } = records; i < length; i++){
            const { addedNodes: addedNodes, removedNodes: removedNodes } = records[i];
            loop(removedNodes, added, removed, $52ca24f3afc1ec72$var$FALSE, $52ca24f3afc1ec72$var$FALSE);
            loop(addedNodes, added, removed, $52ca24f3afc1ec72$var$TRUE, $52ca24f3afc1ec72$var$FALSE);
        }
    });
    observer.add = $52ca24f3afc1ec72$var$add;
    observer.add(root || document);
    return observer;
};


const $19516ec9e1dc890a$var$QSA = "querySelectorAll";
const { document: $19516ec9e1dc890a$var$document, Element: $19516ec9e1dc890a$var$Element, MutationObserver: $19516ec9e1dc890a$var$MutationObserver, Set: $19516ec9e1dc890a$var$Set, WeakMap: $19516ec9e1dc890a$var$WeakMap } = self;
const $19516ec9e1dc890a$var$elements = (element)=>$19516ec9e1dc890a$var$QSA in element;
const { filter: $19516ec9e1dc890a$var$filter } = [];
var $19516ec9e1dc890a$export$2e2bcd8739ae039 = (options)=>{
    const live = new $19516ec9e1dc890a$var$WeakMap;
    const drop = (elements)=>{
        for(let i = 0, { length: length } = elements; i < length; i++)live.delete(elements[i]);
    };
    const flush = ()=>{
        const records = observer.takeRecords();
        for(let i = 0, { length: length } = records; i < length; i++){
            parse($19516ec9e1dc890a$var$filter.call(records[i].removedNodes, $19516ec9e1dc890a$var$elements), false);
            parse($19516ec9e1dc890a$var$filter.call(records[i].addedNodes, $19516ec9e1dc890a$var$elements), true);
        }
    };
    const matches = (element)=>element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    const notifier = (element, connected)=>{
        let selectors;
        if (connected) {
            for(let q, m = matches(element), i = 0, { length: length } = query; i < length; i++)if (m.call(element, q = query[i])) {
                if (!live.has(element)) live.set(element, new $19516ec9e1dc890a$var$Set);
                selectors = live.get(element);
                if (!selectors.has(q)) {
                    selectors.add(q);
                    options.handle(element, connected, q);
                }
            }
        } else if (live.has(element)) {
            selectors = live.get(element);
            live.delete(element);
            selectors.forEach((q)=>{
                options.handle(element, connected, q);
            });
        }
    };
    const parse = (elements, connected = true)=>{
        for(let i = 0, { length: length } = elements; i < length; i++)notifier(elements[i], connected);
    };
    const { query: query } = options;
    const root = options.root || $19516ec9e1dc890a$var$document;
    const observer = (0, $52ca24f3afc1ec72$export$5e14cdade93d6f7b)(notifier, root, $19516ec9e1dc890a$var$MutationObserver);
    const { attachShadow: attachShadow } = $19516ec9e1dc890a$var$Element.prototype;
    if (attachShadow) $19516ec9e1dc890a$var$Element.prototype.attachShadow = function(init) {
        const shadowRoot = attachShadow.call(this, init);
        observer.add(shadowRoot);
        return shadowRoot;
    };
    if (query.length) parse(root[$19516ec9e1dc890a$var$QSA](query));
    return {
        drop: drop,
        flush: flush,
        observer: observer,
        parse: parse
    };
};


const { create: $8f89c991f8e64093$var$create, keys: $8f89c991f8e64093$var$keys } = Object;
const $8f89c991f8e64093$var$attributes = new WeakMap;
const $8f89c991f8e64093$var$lazy = new Set;
const $8f89c991f8e64093$var$query = [];
const $8f89c991f8e64093$var$config = {};
const $8f89c991f8e64093$var$defined = {};
const $8f89c991f8e64093$var$attributeChangedCallback = (records, o)=>{
    for(let h = $8f89c991f8e64093$var$attributes.get(o), i = 0, { length: length } = records; i < length; i++){
        const { target: target, attributeName: attributeName, oldValue: oldValue } = records[i];
        const newValue = target.getAttribute(attributeName);
        h.attributeChanged(attributeName, oldValue, newValue);
    }
};
const $8f89c991f8e64093$var$set = (value, m, l, o)=>{
    const handler = $8f89c991f8e64093$var$create(o, {
        element: {
            enumerable: true,
            value: value
        }
    });
    for(let i = 0, { length: length } = l; i < length; i++)value.addEventListener(l[i].t, handler, l[i].o);
    m.set(value, handler);
    if (handler.init) handler.init();
    const { observedAttributes: observedAttributes } = o;
    if (observedAttributes) {
        const mo = new MutationObserver($8f89c991f8e64093$var$attributeChangedCallback);
        mo.observe(value, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: observedAttributes.map((attributeName)=>{
                if (value.hasAttribute(attributeName)) handler.attributeChanged(attributeName, null, value.getAttribute(attributeName));
                return attributeName;
            })
        });
        $8f89c991f8e64093$var$attributes.set(mo, handler);
    }
    return handler;
};
const { drop: $8f89c991f8e64093$var$drop, flush: $8f89c991f8e64093$var$flush, parse: $8f89c991f8e64093$var$parse } = (0, $19516ec9e1dc890a$export$2e2bcd8739ae039)({
    query: $8f89c991f8e64093$var$query,
    handle (element, connected, selector) {
        const { m: m, l: l, o: o } = $8f89c991f8e64093$var$config[selector];
        const handler = m.get(element) || $8f89c991f8e64093$var$set(element, m, l, o);
        const method = connected ? "connected" : "disconnected";
        if (method in handler) handler[method]();
    }
});
const $8f89c991f8e64093$export$3988ae62b71be9a3 = (selector)=>($8f89c991f8e64093$var$config[selector] || $8f89c991f8e64093$var$attributes).o;
const $8f89c991f8e64093$export$f36d6a7a5c09a23e = (selector, definition)=>{
    if (-1 < $8f89c991f8e64093$var$query.indexOf(selector)) throw new Error("duplicated: " + selector);
    $8f89c991f8e64093$var$flush();
    const listeners = [];
    const retype = $8f89c991f8e64093$var$create(null);
    for(let k = $8f89c991f8e64093$var$keys(definition), i = 0, { length: length } = k; i < length; i++){
        const key = k[i];
        if (/^on/.test(key) && !/Options$/.test(key)) {
            const options = definition[key + "Options"] || false;
            const lower = key.toLowerCase();
            let type = lower.slice(2);
            listeners.push({
                t: type,
                o: options
            });
            retype[type] = key;
            if (lower !== key) {
                type = key.slice(2, 3).toLowerCase() + key.slice(3);
                retype[type] = key;
                listeners.push({
                    t: type,
                    o: options
                });
            }
        }
    }
    if (listeners.length) definition.handleEvent = function(event) {
        this[retype[event.type]](event);
    };
    $8f89c991f8e64093$var$query.push(selector);
    $8f89c991f8e64093$var$config[selector] = {
        m: new WeakMap,
        l: listeners,
        o: definition
    };
    $8f89c991f8e64093$var$parse(document.querySelectorAll(selector));
    $8f89c991f8e64093$export$785f9b878ae51e44(selector);
    if (!$8f89c991f8e64093$var$lazy.has(selector)) $8f89c991f8e64093$var$defined[selector]._();
};
const $8f89c991f8e64093$export$cb4885581b710ca6 = (selector, callback, _)=>{
    $8f89c991f8e64093$var$lazy.add(selector);
    $8f89c991f8e64093$export$f36d6a7a5c09a23e(selector, {
        init () {
            if ($8f89c991f8e64093$var$lazy.has(selector)) {
                $8f89c991f8e64093$var$lazy.delete(selector);
                callback().then(({ default: definition })=>{
                    $8f89c991f8e64093$var$query.splice($8f89c991f8e64093$var$query.indexOf(selector), 1);
                    $8f89c991f8e64093$var$drop(document.querySelectorAll(selector));
                    (_ || $8f89c991f8e64093$export$f36d6a7a5c09a23e)(selector, definition);
                });
            }
        }
    });
};
const $8f89c991f8e64093$export$ba387509dbaf942e = (element)=>{
    if ($8f89c991f8e64093$var$query.length) {
        $8f89c991f8e64093$var$flush();
        $8f89c991f8e64093$var$parse([
            element
        ]);
    }
};
const $8f89c991f8e64093$export$785f9b878ae51e44 = (selector)=>{
    if (!(selector in $8f89c991f8e64093$var$defined)) {
        let _, $ = new (0, $cee2a9123a7e8ef2$export$2e2bcd8739ae039)(($)=>{
            _ = $;
        });
        $8f89c991f8e64093$var$defined[selector] = {
            _: _,
            $: $
        };
    }
    return $8f89c991f8e64093$var$defined[selector].$;
};


var $22560deee8d90fe2$exports = {};
$22560deee8d90fe2$exports = $22560deee8d90fe2$var$onIntersect;
function $22560deee8d90fe2$var$onIntersect(el, opts, onEnter, onExit) {
    if (typeof opts === "function") {
        onExit = onEnter;
        onEnter = opts;
        opts = {};
    }
    onEnter = onEnter || $22560deee8d90fe2$var$noop;
    onExit = onExit || $22560deee8d90fe2$var$noop;
    var wasCalled = false;
    var observer = new window.IntersectionObserver(handler, opts);
    observer.observe(el);
    return function() {
        observer.disconnect();
    };
    function handler(entries, obs) {
        var entry = entries[0];
        // This covers subtle edge cases where the intersection value is 0.
        // See: https://github.com/yoshuawuyts/on-intersect/issues/2
        var isNotIntersecting = typeof entry.isIntersecting === "boolean" ? !entry.isIntersecting : entry.intersectionRatio === 0;
        if (isNotIntersecting) // Make sure it's not called immediately when loaded.
        {
            if (wasCalled) onExit(entry);
        } else onEnter(entry);
        wasCalled = true;
    }
}
function $22560deee8d90fe2$var$noop() {}


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="ultralazy"]', {
    init () {
        this.state = {};
        this.options = {
            ...this.element.dataset
        };
        this.onEnter = this.onEnter.bind(this);
        this.onLoad = this.onLoad.bind(this);
    },
    connected () {
        if (!this.options.manual) this.stopObserving = (0, (/*@__PURE__*/$parcel$interopDefault($22560deee8d90fe2$exports)))(this.element, {}, this.onEnter);
    },
    disconnected () {
        if (!this.options.manual) this.stopObserving();
    },
    onEnter (e) {
        this.loadImg();
        this.stopObserving();
    },
    loadImg () {
        this.element.classList.replace("lazyload", "lazyloading");
        const newSrc = this.element.dataset.src;
        if (newSrc) this.element.src = newSrc;
        const newSrcset = this.element.dataset.srcset;
        if (newSrcset) {
            if (this.element.dataset.sizes === "auto" && this.element.offsetWidth) this.element.sizes = `${this.element.offsetWidth}px`;
            this.element.srcset = newSrcset;
        }
    },
    onLoad () {
        if (this.element.classList.contains("lazyloading")) this.element.classList.replace("lazyloading", "lazyloaded");
    },
    onTriggerLoad () {
        const classList = this.element.classList;
        if (!classList.contains("lazyloading") && !classList.contains("lazyloaded")) this.loadImg();
    }
});



var $4d6a626fa18fbb17$exports = {};







/*!
 * Flickity v2.2.2
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */ (function(window1, factory) {
    // universal module definition
    if (typeof define == "function" && define.amd) // AMD
    define([
        "./flickity",
        "./drag",
        "./prev-next-button",
        "./page-dots",
        "./player",
        "./add-remove-cell",
        "./lazyload"
    ], factory);
    else if (0, $4d6a626fa18fbb17$exports) // CommonJS
    $4d6a626fa18fbb17$exports = factory((parcelRequire("g0Txk")), (parcelRequire("40VrA")), (parcelRequire("bEazz")), (parcelRequire("gheIK")), (parcelRequire("4H331")), (parcelRequire("ertaa")), (parcelRequire("28ytO")));
})(window, function factory(Flickity) {
    return Flickity;
});



(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="slider"]', {
    init () {
        this.$slider = this.element.querySelector("[data-slider]");
        this.$caption = this.element.querySelector("[data-figcaption]");
        this.count = this.$slider.children.length;
        this.loadImage = this.loadImage.bind(this);
    },
    initFlickity () {
        this.flkty = new (0, (/*@__PURE__*/$parcel$interopDefault($4d6a626fa18fbb17$exports)))(this.$slider, {
            pageDots: false,
            arrowShape: "M39.91 10.09 L0 50 L39.91 89.91 L65.61 89.91 L34.27 59.27 L100 59.27 L100 40.73 L34.27 40.73 L65.61 10.09 L39.91 10.09 Z",
            adaptiveHeight: true,
            wrapAround: true
        });
        this.flkty.on("change", ()=>{
            const selected = this.flkty.selectedElement;
            this.$caption.innerHTML = selected.dataset.caption || "";
        });
        // force Ultralazy images to load 
        this.flkty.on("select", this.loadImage);
        setTimeout(()=>{
            this.loadImage();
        });
    },
    loadImage () {
        const selected = this.flkty.selectedElement;
        const img = selected.querySelector("img");
        if (img) img.dispatchEvent(new CustomEvent("triggerLoad"));
    },
    connected () {
        if (this.count > 1) this.initFlickity();
    },
    disconnected () {
        if (this.flkty) this.flkty.destroy();
    }
});



const $13c3ef9ba45958e0$var$CustomIcons = [
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Circle-Red.svg",
        name: "circle-red"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Circle-Green.svg",
        name: "circle-green"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Circle-Blue.svg",
        name: "circle-blue"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Circle-Yellow.svg",
        name: "circle-yellow"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Square-Red.svg",
        name: "square-red"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Square-Green.svg",
        name: "square-green"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Square-Blue.svg",
        name: "square-blue"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Square-Yellow.svg",
        name: "square-yellow"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Triangle-Red.svg",
        name: "triangle-red"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Triangle-Green.svg",
        name: "triangle-green"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Triangle-Blue.svg",
        name: "triangle-blue"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Triangle-Yellow.svg",
        name: "triangle-yellow"
    },
    {
        src: window.SITE_BASE + "/assets/images/map-icons/Map-Icons_Circle.svg",
        name: "circle"
    }
];
var $13c3ef9ba45958e0$export$2e2bcd8739ae039 = $13c3ef9ba45958e0$var$CustomIcons;



const $6999c02c9fa8589c$export$8f45430ccf837300 = {
    "red": "#fa4003",
    "blue": "#267dde",
    "yellow": "#ffed00",
    "green": "#45c905"
};
function $6999c02c9fa8589c$export$6483924f57bebc09(path) {
    return path.replace(window.SITE_BASE, "").replace(/^\/+/g, "");
}


/**
 * @module helpers
 */ /**
 * Earth Radius used with the Harvesine formula and approximates using a spherical (non-ellipsoid) Earth.
 *
 * @memberof helpers
 * @type {number}
 */ var $3a491b43ab6a4f6e$export$e3a1ee0e9945697f = 6371008.8;
var $3a491b43ab6a4f6e$export$f929e47acbed771a = {
    centimeters: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f * 100,
    centimetres: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f * 100,
    degrees: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f / 111325,
    feet: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f * 3.28084,
    inches: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f * 39.37,
    kilometers: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f / 1000,
    kilometres: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f / 1000,
    meters: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f,
    metres: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f,
    miles: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f * 1000,
    millimetres: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f * 1000,
    nauticalmiles: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $3a491b43ab6a4f6e$export$e3a1ee0e9945697f * 1.0936
};
var $3a491b43ab6a4f6e$export$95cef4899be7420 = {
    centimeters: 100,
    centimetres: 100,
    degrees: 1 / 111325,
    feet: 3.28084,
    inches: 39.37,
    kilometers: 0.001,
    kilometres: 0.001,
    meters: 1,
    metres: 1,
    miles: 1 / 1609.344,
    millimeters: 1000,
    millimetres: 1000,
    nauticalmiles: 1 / 1852,
    radians: 1 / $3a491b43ab6a4f6e$export$e3a1ee0e9945697f,
    yards: 1.0936133
};
var $3a491b43ab6a4f6e$export$44665ce4f7f4c82b = {
    acres: 0.000247105,
    centimeters: 10000,
    centimetres: 10000,
    feet: 10.763910417,
    hectares: 0.0001,
    inches: 1550.003100006,
    kilometers: 0.000001,
    kilometres: 0.000001,
    meters: 1,
    metres: 1,
    miles: 3.86e-7,
    millimeters: 1000000,
    millimetres: 1000000,
    yards: 1.195990046
};
function $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options) {
    if (options === void 0) options = {};
    var feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
function $3a491b43ab6a4f6e$export$42a7622cbf932bb(type, coordinates, _options) {
    if (_options === void 0) _options = {};
    switch(type){
        case "Point":
            return $3a491b43ab6a4f6e$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $3a491b43ab6a4f6e$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $3a491b43ab6a4f6e$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $3a491b43ab6a4f6e$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $3a491b43ab6a4f6e$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $3a491b43ab6a4f6e$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
function $3a491b43ab6a4f6e$export$105684a3041cb6f3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$3a491b43ab6a4f6e$export$7e4aa119212bc614(coordinates[0]) || !$3a491b43ab6a4f6e$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    var geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options);
}
function $3a491b43ab6a4f6e$export$9f048bf86ee2e9d2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $3a491b43ab6a4f6e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $3a491b43ab6a4f6e$export$105684a3041cb6f3(coords, properties);
    }), options);
}
function $3a491b43ab6a4f6e$export$b7b19aa0ee06c73(coordinates, properties, options) {
    if (options === void 0) options = {};
    for(var _i = 0, coordinates_1 = coordinates; _i < coordinates_1.length; _i++){
        var ring = coordinates_1[_i];
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        for(var j = 0; j < ring[ring.length - 1].length; j++){
            // Check if first point of Polygon contains two numbers
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    var geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options);
}
function $3a491b43ab6a4f6e$export$8869eb68a940f9c2(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $3a491b43ab6a4f6e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $3a491b43ab6a4f6e$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
function $3a491b43ab6a4f6e$export$98ec381bb06902c3(coordinates, properties, options) {
    if (options === void 0) options = {};
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    var geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options);
}
function $3a491b43ab6a4f6e$export$74f7306c35db993f(coordinates, properties, options) {
    if (options === void 0) options = {};
    return $3a491b43ab6a4f6e$export$4717c67ac3e5e04d(coordinates.map(function(coords) {
        return $3a491b43ab6a4f6e$export$98ec381bb06902c3(coords, properties);
    }), options);
}
function $3a491b43ab6a4f6e$export$4717c67ac3e5e04d(features, options) {
    if (options === void 0) options = {};
    var fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
function $3a491b43ab6a4f6e$export$bd735230309493da(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options);
}
function $3a491b43ab6a4f6e$export$335fc20ed6b6dbb6(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options);
}
function $3a491b43ab6a4f6e$export$79bd594da96638d3(coordinates, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options);
}
function $3a491b43ab6a4f6e$export$9242f1e18250422a(geometries, properties, options) {
    if (options === void 0) options = {};
    var geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $3a491b43ab6a4f6e$export$ced6ed16dfd6a264(geom, properties, options);
}
function $3a491b43ab6a4f6e$export$2077e0241d6afd3c(num, precision) {
    if (precision === void 0) precision = 0;
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
function $3a491b43ab6a4f6e$export$f234631d6a2eedf8(radians, units) {
    if (units === void 0) units = "kilometers";
    var factor = $3a491b43ab6a4f6e$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
function $3a491b43ab6a4f6e$export$a2280f7debae8f10(distance, units) {
    if (units === void 0) units = "kilometers";
    var factor = $3a491b43ab6a4f6e$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
function $3a491b43ab6a4f6e$export$c7a138e00a89bd01(distance, units) {
    return $3a491b43ab6a4f6e$export$c41dd2a8460d3196($3a491b43ab6a4f6e$export$a2280f7debae8f10(distance, units));
}
function $3a491b43ab6a4f6e$export$f2077d29c73b33ec(bearing) {
    var angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
function $3a491b43ab6a4f6e$export$c41dd2a8460d3196(radians) {
    var degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
function $3a491b43ab6a4f6e$export$c9fcf1a7df975d78(degrees) {
    var radians = degrees % 360;
    return radians * Math.PI / 180;
}
function $3a491b43ab6a4f6e$export$ea1536a749e80563(length, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "kilometers";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $3a491b43ab6a4f6e$export$f234631d6a2eedf8($3a491b43ab6a4f6e$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
function $3a491b43ab6a4f6e$export$2e65e2c759f7e341(area, originalUnit, finalUnit) {
    if (originalUnit === void 0) originalUnit = "meters";
    if (finalUnit === void 0) finalUnit = "kilometers";
    if (!(area >= 0)) throw new Error("area must be a positive number");
    var startFactor = $3a491b43ab6a4f6e$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    var finalFactor = $3a491b43ab6a4f6e$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
function $3a491b43ab6a4f6e$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
function $3a491b43ab6a4f6e$export$a6cdc56e425d0d0a(input) {
    return !!input && input.constructor === Object;
}
function $3a491b43ab6a4f6e$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach(function(num) {
        if (!$3a491b43ab6a4f6e$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
function $3a491b43ab6a4f6e$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}


/**
 * Callback for coordEach
 *
 * @callback coordEachCallback
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Iterate over coordinates in any GeoJSON object, similar to Array.forEach()
 *
 * @name coordEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentCoord, coordIndex, featureIndex, multiFeatureIndex)
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordEach(features, function (currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $dea6334ea950598d$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    // Handles null Geometry -- Skips this GeoJSON
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            // Handles null Geometry -- Skips this geometry
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($dea6334ea950598d$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
/**
 * Callback for coordReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback coordReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Array<number>} currentCoord The current coordinate being processed.
 * @param {number} coordIndex The current index of the coordinate being processed.
 * Starts at index 0, if an initialValue is provided, and at index 1 otherwise.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 */ /**
 * Reduce coordinates in any GeoJSON object, similar to Array.reduce()
 *
 * @name coordReduce
 * @param {FeatureCollection|Geometry|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentCoord, coordIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @param {boolean} [excludeWrapCoord=false] whether or not to include the final coordinate of LinearRings that wraps the ring in its iteration.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.coordReduce(features, function (previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentCoord
 *   //=coordIndex
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentCoord;
 * });
 */ function $dea6334ea950598d$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $dea6334ea950598d$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === undefined) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
/**
 * Callback for propEach
 *
 * @callback propEachCallback
 * @param {Object} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over properties in any GeoJSON object, similar to Array.forEach()
 *
 * @name propEach
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentProperties, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propEach(features, function (currentProperties, featureIndex) {
 *   //=currentProperties
 *   //=featureIndex
 * });
 */ function $dea6334ea950598d$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
/**
 * Callback for propReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback propReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {*} currentProperties The current Properties being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce properties in any GeoJSON object into a single value,
 * similar to how Array.reduce works. However, in this case we lazily run
 * the reduction, so an array of all properties is unnecessary.
 *
 * @name propReduce
 * @param {FeatureCollection|Feature} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentProperties, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.propReduce(features, function (previousValue, currentProperties, featureIndex) {
 *   //=previousValue
 *   //=currentProperties
 *   //=featureIndex
 *   return currentProperties
 * });
 */ function $dea6334ea950598d$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $dea6334ea950598d$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
/**
 * Callback for featureEach
 *
 * @callback featureEachCallback
 * @param {Feature<any>} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Iterate over features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name featureEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.featureEach(features, function (currentFeature, featureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 * });
 */ function $dea6334ea950598d$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
/**
 * Callback for featureReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback featureReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name featureReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {"foo": "bar"}),
 *   turf.point([36, 53], {"hello": "world"})
 * ]);
 *
 * turf.featureReduce(features, function (previousValue, currentFeature, featureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   return currentFeature
 * });
 */ function $dea6334ea950598d$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $dea6334ea950598d$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
/**
 * Get all coordinates from any GeoJSON object.
 *
 * @name coordAll
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @returns {Array<Array<number>>} coordinate position array
 * @example
 * var features = turf.featureCollection([
 *   turf.point([26, 37], {foo: 'bar'}),
 *   turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * var coords = turf.coordAll(features);
 * //= [[26, 37], [36, 53]]
 */ function $dea6334ea950598d$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $dea6334ea950598d$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
/**
 * Callback for geomEach
 *
 * @callback geomEachCallback
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Iterate over each geometry in any GeoJSON object, similar to Array.forEach()
 *
 * @name geomEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @returns {void}
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomEach(features, function (currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 * });
 */ function $dea6334ea950598d$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    // This logic may look a little weird. The reason why it is that way
    // is because it's trying to be fast. GeoJSON supports multiple kinds
    // of objects at its root: FeatureCollection, Features, Geometries.
    // This function has the responsibility of handling all of them, and that
    // means that some of the `for` loops you see below actually just don't apply
    // to certain inputs. For instance, if you give this just a
    // Point geometry, then both loops are short-circuited and all we do
    // is gradually rename the input until it's called 'geometry'.
    //
    // This also aims to allocate as few resources as possible: just a
    // few numbers and booleans, rather than any temporary arrays as would
    // be required with the normalization approach.
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : undefined;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : undefined;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            // Handle null Geometry
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        // Only increase `featureIndex` per each feature
        featureIndex++;
    }
}
/**
 * Callback for geomReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback geomReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Geometry} currentGeometry The current Geometry being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {Object} featureProperties The current Feature Properties being processed.
 * @param {Array<number>} featureBBox The current Feature BBox being processed.
 * @param {number|string} featureId The current Feature Id being processed.
 */ /**
 * Reduce geometry in any GeoJSON object, similar to Array.reduce().
 *
 * @name geomReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.point([36, 53], {hello: 'world'})
 * ]);
 *
 * turf.geomReduce(features, function (previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
 *   //=previousValue
 *   //=currentGeometry
 *   //=featureIndex
 *   //=featureProperties
 *   //=featureBBox
 *   //=featureId
 *   return currentGeometry
 * });
 */ function $dea6334ea950598d$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $dea6334ea950598d$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
/**
 * Callback for flattenEach
 *
 * @callback flattenEachCallback
 * @param {Feature} currentFeature The current flattened feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Iterate over flattened features in any GeoJSON object, similar to
 * Array.forEach.
 *
 * @name flattenEach
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (currentFeature, featureIndex, multiFeatureIndex)
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenEach(features, function (currentFeature, featureIndex, multiFeatureIndex) {
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 * });
 */ function $dea6334ea950598d$export$12cba8b31beb353b(geojson, callback) {
    $dea6334ea950598d$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        // Callback for single geometry
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $3a491b43ab6a4f6e$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        // Callback for multi-geometry
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $3a491b43ab6a4f6e$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
/**
 * Callback for flattenReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback flattenReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature} currentFeature The current Feature being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 */ /**
 * Reduce flattened features in any GeoJSON object, similar to Array.reduce().
 *
 * @name flattenReduce
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON object
 * @param {Function} callback a method that takes (previousValue, currentFeature, featureIndex, multiFeatureIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var features = turf.featureCollection([
 *     turf.point([26, 37], {foo: 'bar'}),
 *     turf.multiPoint([[40, 30], [36, 53]], {hello: 'world'})
 * ]);
 *
 * turf.flattenReduce(features, function (previousValue, currentFeature, featureIndex, multiFeatureIndex) {
 *   //=previousValue
 *   //=currentFeature
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   return currentFeature
 * });
 */ function $dea6334ea950598d$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $dea6334ea950598d$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === undefined) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
/**
 * Callback for segmentEach
 *
 * @callback segmentEachCallback
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 * @returns {void}
 */ /**
 * Iterate over 2-vertex line segment in any GeoJSON object, similar to Array.forEach()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex)
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentEach(polygon, function (currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //=currentSegment
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   //=segmentIndex
 * });
 *
 * // Calculate the total number of segments
 * var total = 0;
 * turf.segmentEach(polygon, function () {
 *     total++;
 * });
 */ function $dea6334ea950598d$export$d3ecc1efb2be121e(geojson, callback) {
    $dea6334ea950598d$export$12cba8b31beb353b(geojson, function(feature, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        // Exclude null Geometries
        if (!feature.geometry) return;
        // (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
        var type = feature.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        // Generate 2-vertex line segments
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($dea6334ea950598d$export$6e011439fde007ae(feature, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            // Simulating a meta.coordReduce() since `reduce` operations cannot be stopped by returning `false`
            if (previousCoords === undefined || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $3a491b43ab6a4f6e$export$98ec381bb06902c3)([
                previousCoords,
                currentCoord
            ], feature.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
/**
 * Callback for segmentReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback segmentReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentSegment The current Segment being processed.
 * @param {number} featureIndex The current index of the Feature being processed.
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed.
 * @param {number} geometryIndex The current index of the Geometry being processed.
 * @param {number} segmentIndex The current index of the Segment being processed.
 */ /**
 * Reduce 2-vertex line segment in any GeoJSON object, similar to Array.reduce()
 * (Multi)Point geometries do not contain segments therefore they are ignored during this operation.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson any GeoJSON
 * @param {Function} callback a method that takes (previousValue, currentSegment, currentIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {void}
 * @example
 * var polygon = turf.polygon([[[-50, 5], [-40, -10], [-50, -10], [-40, 5], [-50, 5]]]);
 *
 * // Iterate over GeoJSON by 2-vertex segments
 * turf.segmentReduce(polygon, function (previousSegment, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
 *   //= previousSegment
 *   //= currentSegment
 *   //= featureIndex
 *   //= multiFeatureIndex
 *   //= geometryIndex
 *   //= segmentIndex
 *   return currentSegment
 * });
 *
 * // Calculate the total number of segments
 * var initialValue = 0
 * var total = turf.segmentReduce(polygon, function (previousValue) {
 *     previousValue++;
 *     return previousValue;
 * }, initialValue);
 */ function $dea6334ea950598d$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $dea6334ea950598d$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === undefined) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
/**
 * Callback for lineEach
 *
 * @callback lineEachCallback
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Iterate over line or ring coordinates in LineString, Polygon, MultiLineString, MultiPolygon Features or Geometries,
 * similar to Array.forEach.
 *
 * @name lineEach
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @example
 * var multiLine = turf.multiLineString([
 *   [[26, 37], [35, 45]],
 *   [[36, 53], [38, 50], [41, 55]]
 * ]);
 *
 * turf.lineEach(multiLine, function (currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 * });
 */ function $dea6334ea950598d$export$985a91771cfc783d(geojson, callback) {
    // validation
    if (!geojson) throw new Error("geojson is required");
    $dea6334ea950598d$export$12cba8b31beb353b(geojson, function(feature, featureIndex, multiFeatureIndex) {
        if (feature.geometry === null) return;
        var type = feature.geometry.type;
        var coords = feature.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $3a491b43ab6a4f6e$export$98ec381bb06902c3)(coords[geometryIndex], feature.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
/**
 * Callback for lineReduce
 *
 * The first time the callback function is called, the values provided as arguments depend
 * on whether the reduce method has an initialValue argument.
 *
 * If an initialValue is provided to the reduce method:
 *  - The previousValue argument is initialValue.
 *  - The currentValue argument is the value of the first element present in the array.
 *
 * If an initialValue is not provided:
 *  - The previousValue argument is the value of the first element present in the array.
 *  - The currentValue argument is the value of the second element present in the array.
 *
 * @callback lineReduceCallback
 * @param {*} previousValue The accumulated value previously returned in the last invocation
 * of the callback, or initialValue, if supplied.
 * @param {Feature<LineString>} currentLine The current LineString|LinearRing being processed.
 * @param {number} featureIndex The current index of the Feature being processed
 * @param {number} multiFeatureIndex The current index of the Multi-Feature being processed
 * @param {number} geometryIndex The current index of the Geometry being processed
 */ /**
 * Reduce features in any GeoJSON object, similar to Array.reduce().
 *
 * @name lineReduce
 * @param {Geometry|Feature<LineString|Polygon|MultiLineString|MultiPolygon>} geojson object
 * @param {Function} callback a method that takes (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex)
 * @param {*} [initialValue] Value to use as the first argument to the first call of the callback.
 * @returns {*} The value that results from the reduction.
 * @example
 * var multiPoly = turf.multiPolygon([
 *   turf.polygon([[[12,48],[2,41],[24,38],[12,48]], [[9,44],[13,41],[13,45],[9,44]]]),
 *   turf.polygon([[[5, 5], [0, 0], [2, 2], [4, 4], [5, 5]]])
 * ]);
 *
 * turf.lineReduce(multiPoly, function (previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
 *   //=previousValue
 *   //=currentLine
 *   //=featureIndex
 *   //=multiFeatureIndex
 *   //=geometryIndex
 *   return currentLine
 * });
 */ function $dea6334ea950598d$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $dea6334ea950598d$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === undefined) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
/**
 * Finds a particular 2-vertex LineString Segment from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 * Point & MultiPoint will always return null.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.segmentIndex=0] Segment Index
 * @param {Object} [options.properties={}] Translate Properties to output LineString
 * @param {BBox} [options.bbox={}] Translate BBox to output LineString
 * @param {number|string} [options.id={}] Translate Id to output LineString
 * @returns {Feature<LineString>} 2-vertex GeoJSON Feature LineString
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findSegment(multiLine);
 * // => Feature<LineString<[[10, 10], [50, 30]]>>
 *
 * // First Segment of 2nd Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: 1});
 * // => Feature<LineString<[[-10, -10], [-50, -30]]>>
 *
 * // Last Segment of Last Multi Feature
 * turf.findSegment(multiLine, {multiFeatureIndex: -1, segmentIndex: -1});
 * // => Feature<LineString<[[-50, -30], [-30, -40]]>>
 */ function $dea6334ea950598d$export$2b6ba91fd8680d67(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $3a491b43ab6a4f6e$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find SegmentIndex
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $3a491b43ab6a4f6e$export$98ec381bb06902c3)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $3a491b43ab6a4f6e$export$98ec381bb06902c3)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $3a491b43ab6a4f6e$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $3a491b43ab6a4f6e$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
/**
 * Finds a particular Point from a GeoJSON using `@turf/meta` indexes.
 *
 * Negative indexes are permitted.
 *
 * @param {FeatureCollection|Feature|Geometry} geojson Any GeoJSON Feature or Geometry
 * @param {Object} [options={}] Optional parameters
 * @param {number} [options.featureIndex=0] Feature Index
 * @param {number} [options.multiFeatureIndex=0] Multi-Feature Index
 * @param {number} [options.geometryIndex=0] Geometry Index
 * @param {number} [options.coordIndex=0] Coord Index
 * @param {Object} [options.properties={}] Translate Properties to output Point
 * @param {BBox} [options.bbox={}] Translate BBox to output Point
 * @param {number|string} [options.id={}] Translate Id to output Point
 * @returns {Feature<Point>} 2-vertex GeoJSON Feature Point
 * @example
 * var multiLine = turf.multiLineString([
 *     [[10, 10], [50, 30], [30, 40]],
 *     [[-10, -10], [-50, -30], [-30, -40]]
 * ]);
 *
 * // First Segment (defaults are 0)
 * turf.findPoint(multiLine);
 * // => Feature<Point<[10, 10]>>
 *
 * // First Segment of the 2nd Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: 1});
 * // => Feature<Point<[-10, -10]>>
 *
 * // Last Segment of last Multi-Feature
 * turf.findPoint(multiLine, {multiFeatureIndex: -1, coordIndex: -1});
 * // => Feature<Point<[-30, -40]>>
 */ function $dea6334ea950598d$export$ed60ae5df1bac687(geojson, options) {
    // Optional Parameters
    options = options || {};
    if (!(0, $3a491b43ab6a4f6e$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    // Find FeatureIndex
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    // Find Coord Index
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $3a491b43ab6a4f6e$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $3a491b43ab6a4f6e$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $3a491b43ab6a4f6e$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $3a491b43ab6a4f6e$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $3a491b43ab6a4f6e$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $3a491b43ab6a4f6e$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}


/**
 * Takes a set of features, calculates the bbox of all input features, and returns a bounding box.
 *
 * @name bbox
 * @param {GeoJSON} geojson any GeoJSON object
 * @returns {BBox} bbox extent in [minX, minY, maxX, maxY] order
 * @example
 * var line = turf.lineString([[-74, 40], [-78, 42], [-82, 35]]);
 * var bbox = turf.bbox(line);
 * var bboxPolygon = turf.bboxPolygon(bbox);
 *
 * //addToMap
 * var addToMap = [line, bboxPolygon]
 */ function $ef50c33c64ec8420$var$bbox(geojson) {
    var result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $dea6334ea950598d$export$6e011439fde007ae)(geojson, function(coord) {
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
$ef50c33c64ec8420$var$bbox["default"] = $ef50c33c64ec8420$var$bbox;
var $ef50c33c64ec8420$export$2e2bcd8739ae039 = $ef50c33c64ec8420$var$bbox;



function $f00c2b5e96c21de4$export$2e2bcd8739ae039(bbox, options) {
    if (options === void 0) options = {};
    // Convert BBox positions to Numbers
    // No performance loss for including Number()
    // https://github.com/Turfjs/turf/issues/1119
    var west = Number(bbox[0]);
    var south = Number(bbox[1]);
    var east = Number(bbox[2]);
    var north = Number(bbox[3]);
    if (bbox.length === 6) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    var lowLeft = [
        west,
        south
    ];
    var topLeft = [
        west,
        north
    ];
    var topRight = [
        east,
        north
    ];
    var lowRight = [
        east,
        south
    ];
    return (0, $3a491b43ab6a4f6e$export$b7b19aa0ee06c73)([
        [
            lowLeft,
            lowRight,
            topRight,
            topLeft,
            lowLeft
        ]
    ], options.properties, {
        bbox: bbox,
        id: options.id
    });
}



// Note: change RADIUS => earthRadius
var $17e543fcbc4d550c$var$RADIUS = 6378137;
function $17e543fcbc4d550c$export$2e2bcd8739ae039(geojson) {
    return (0, $dea6334ea950598d$export$30055ae7bd157809)(geojson, function(value, geom) {
        return value + $17e543fcbc4d550c$var$calculateArea(geom);
    }, 0);
}
/**
 * Calculate Area
 *
 * @private
 * @param {Geometry} geom GeoJSON Geometries
 * @returns {number} area
 */ function $17e543fcbc4d550c$var$calculateArea(geom) {
    var total = 0;
    var i;
    switch(geom.type){
        case "Polygon":
            return $17e543fcbc4d550c$var$polygonArea(geom.coordinates);
        case "MultiPolygon":
            for(i = 0; i < geom.coordinates.length; i++)total += $17e543fcbc4d550c$var$polygonArea(geom.coordinates[i]);
            return total;
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
            return 0;
    }
    return 0;
}
function $17e543fcbc4d550c$var$polygonArea(coords) {
    var total = 0;
    if (coords && coords.length > 0) {
        total += Math.abs($17e543fcbc4d550c$var$ringArea(coords[0]));
        for(var i = 1; i < coords.length; i++)total -= Math.abs($17e543fcbc4d550c$var$ringArea(coords[i]));
    }
    return total;
}
/**
 * @private
 * Calculate the approximate area of the polygon were it projected onto the earth.
 * Note that this area will be positive if ring is oriented clockwise, otherwise it will be negative.
 *
 * Reference:
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for Polygons on a Sphere",
 * JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007 https://trs.jpl.nasa.gov/handle/2014/40409
 *
 * @param {Array<Array<number>>} coords Ring Coordinates
 * @returns {number} The approximate signed geodesic area of the polygon in square meters.
 */ function $17e543fcbc4d550c$var$ringArea(coords) {
    var p1;
    var p2;
    var p3;
    var lowerIndex;
    var middleIndex;
    var upperIndex;
    var i;
    var total = 0;
    var coordsLength = coords.length;
    if (coordsLength > 2) {
        for(i = 0; i < coordsLength; i++){
            if (i === coordsLength - 2) {
                // i = N-2
                lowerIndex = coordsLength - 2;
                middleIndex = coordsLength - 1;
                upperIndex = 0;
            } else if (i === coordsLength - 1) {
                // i = N-1
                lowerIndex = coordsLength - 1;
                middleIndex = 0;
                upperIndex = 1;
            } else {
                // i = 0 to N-3
                lowerIndex = i;
                middleIndex = i + 1;
                upperIndex = i + 2;
            }
            p1 = coords[lowerIndex];
            p2 = coords[middleIndex];
            p3 = coords[upperIndex];
            total += ($17e543fcbc4d550c$var$rad(p3[0]) - $17e543fcbc4d550c$var$rad(p1[0])) * Math.sin($17e543fcbc4d550c$var$rad(p2[1]));
        }
        total = total * $17e543fcbc4d550c$var$RADIUS * $17e543fcbc4d550c$var$RADIUS / 2;
    }
    return total;
}
function $17e543fcbc4d550c$var$rad(num) {
    return num * Math.PI / 180;
}




/**
 * Takes a {@link Feature} or {@link FeatureCollection} and returns the absolute center point of all features.
 *
 * @name center
 * @param {GeoJSON} geojson GeoJSON to be centered
 * @param {Object} [options={}] Optional parameters
 * @param {Object} [options.properties={}] Translate GeoJSON Properties to Point
 * @param {Object} [options.bbox={}] Translate GeoJSON BBox to Point
 * @param {Object} [options.id={}] Translate GeoJSON Id to Point
 * @returns {Feature<Point>} a Point feature at the absolute center point of all input features
 * @example
 * var features = turf.points([
 *   [-97.522259, 35.4691],
 *   [-97.502754, 35.463455],
 *   [-97.508269, 35.463245]
 * ]);
 *
 * var center = turf.center(features);
 *
 * //addToMap
 * var addToMap = [features, center]
 * center.properties['marker-size'] = 'large';
 * center.properties['marker-color'] = '#000';
 */ function $3ca9c20d67fae5ec$var$center(geojson, options) {
    if (options === void 0) options = {};
    var ext = (0, $ef50c33c64ec8420$export$2e2bcd8739ae039)(geojson);
    var x = (ext[0] + ext[2]) / 2;
    var y = (ext[1] + ext[3]) / 2;
    return (0, $3a491b43ab6a4f6e$export$105684a3041cb6f3)([
        x,
        y
    ], options.properties, options);
}
var $3ca9c20d67fae5ec$export$2e2bcd8739ae039 = $3ca9c20d67fae5ec$var$center;


var $6ac1a5641367fc62$exports = {};
var $ba974ad32e0bf6f4$exports = {};
"use strict";
/**
 * Remove a range of items from an array
 *
 * @function removeItems
 * @param {Array<*>} arr The target array
 * @param {number} startIdx The index to begin removing from (inclusive)
 * @param {number} removeCount How many items to remove
 */ $ba974ad32e0bf6f4$exports = function removeItems(arr, startIdx, removeCount) {
    var i, length = arr.length;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    var len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
};


var $6f76f8235b7895c0$exports = {};

var $6f76f8235b7895c0$var$scheduler = (parcelRequire("1DJsI"))();

var $Jm0Yx = parcelRequire("Jm0Yx");
var $6f76f8235b7895c0$var$perf;
$6f76f8235b7895c0$var$nanotiming.disabled = true;
try {
    $6f76f8235b7895c0$var$perf = window.performance;
    $6f76f8235b7895c0$var$nanotiming.disabled = window.localStorage.DISABLE_NANOTIMING === "true" || !$6f76f8235b7895c0$var$perf.mark;
} catch (e) {}
$6f76f8235b7895c0$exports = $6f76f8235b7895c0$var$nanotiming;
function $6f76f8235b7895c0$var$nanotiming(name) {
    $Jm0Yx.equal(typeof name, "string", "nanotiming: name should be type string");
    if ($6f76f8235b7895c0$var$nanotiming.disabled) return $6f76f8235b7895c0$var$noop;
    var uuid = ($6f76f8235b7895c0$var$perf.now() * 10000).toFixed() % Number.MAX_SAFE_INTEGER;
    var startName = "start-" + uuid + "-" + name;
    $6f76f8235b7895c0$var$perf.mark(startName);
    function end(cb) {
        var endName = "end-" + uuid + "-" + name;
        $6f76f8235b7895c0$var$perf.mark(endName);
        $6f76f8235b7895c0$var$scheduler.push(function() {
            var err = null;
            try {
                var measureName = name + " [" + uuid + "]";
                $6f76f8235b7895c0$var$perf.measure(measureName, startName, endName);
                $6f76f8235b7895c0$var$perf.clearMarks(startName);
                $6f76f8235b7895c0$var$perf.clearMarks(endName);
            } catch (e) {
                err = e;
            }
            if (cb) cb(err, name);
        });
    }
    end.uuid = uuid;
    return end;
}
function $6f76f8235b7895c0$var$noop(cb) {
    if (cb) $6f76f8235b7895c0$var$scheduler.push(function() {
        cb(new Error("nanotiming: performance API unavailable"));
    });
}



var $Jm0Yx = parcelRequire("Jm0Yx");
$6ac1a5641367fc62$exports = $6ac1a5641367fc62$var$Nanobus;
function $6ac1a5641367fc62$var$Nanobus(name) {
    if (!(this instanceof $6ac1a5641367fc62$var$Nanobus)) return new $6ac1a5641367fc62$var$Nanobus(name);
    this._name = name || "nanobus";
    this._starListeners = [];
    this._listeners = {};
}
$6ac1a5641367fc62$var$Nanobus.prototype.emit = function(eventName) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.emit: eventName should be type string or symbol");
    var data = [];
    for(var i = 1, len = arguments.length; i < len; i++)data.push(arguments[i]);
    var emitTiming = $6f76f8235b7895c0$exports(this._name + "('" + eventName.toString() + "')");
    var listeners = this._listeners[eventName];
    if (listeners && listeners.length > 0) this._emit(this._listeners[eventName], data);
    if (this._starListeners.length > 0) this._emit(this._starListeners, eventName, data, emitTiming.uuid);
    emitTiming();
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.on = $6ac1a5641367fc62$var$Nanobus.prototype.addListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.on: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.on: listener should be type function");
    if (eventName === "*") this._starListeners.push(listener);
    else {
        if (!this._listeners[eventName]) this._listeners[eventName] = [];
        this._listeners[eventName].push(listener);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.prependListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.prependListener: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.prependListener: listener should be type function");
    if (eventName === "*") this._starListeners.unshift(listener);
    else {
        if (!this._listeners[eventName]) this._listeners[eventName] = [];
        this._listeners[eventName].unshift(listener);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.once = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.once: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.once: listener should be type function");
    var self = this;
    this.on(eventName, once);
    function once() {
        listener.apply(self, arguments);
        self.removeListener(eventName, once);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.prependOnceListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.prependOnceListener: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.prependOnceListener: listener should be type function");
    var self = this;
    this.prependListener(eventName, once);
    function once() {
        listener.apply(self, arguments);
        self.removeListener(eventName, once);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.removeListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.removeListener: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.removeListener: listener should be type function");
    if (eventName === "*") {
        this._starListeners = this._starListeners.slice();
        return remove(this._starListeners, listener);
    } else {
        if (typeof this._listeners[eventName] !== "undefined") this._listeners[eventName] = this._listeners[eventName].slice();
        return remove(this._listeners[eventName], listener);
    }
    function remove(arr, listener) {
        if (!arr) return;
        var index = arr.indexOf(listener);
        if (index !== -1) {
            $ba974ad32e0bf6f4$exports(arr, index, 1);
            return true;
        }
    }
};
$6ac1a5641367fc62$var$Nanobus.prototype.removeAllListeners = function(eventName) {
    if (eventName) {
        if (eventName === "*") this._starListeners = [];
        else this._listeners[eventName] = [];
    } else {
        this._starListeners = [];
        this._listeners = {};
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.listeners = function(eventName) {
    var listeners = eventName !== "*" ? this._listeners[eventName] : this._starListeners;
    var ret = [];
    if (listeners) {
        var ilength = listeners.length;
        for(var i = 0; i < ilength; i++)ret.push(listeners[i]);
    }
    return ret;
};
$6ac1a5641367fc62$var$Nanobus.prototype._emit = function(arr, eventName, data, uuid) {
    if (typeof arr === "undefined") return;
    if (arr.length === 0) return;
    if (data === undefined) {
        data = eventName;
        eventName = null;
    }
    if (eventName) {
        if (uuid !== undefined) data = [
            eventName
        ].concat(data, uuid);
        else data = [
            eventName
        ].concat(data);
    }
    var length = arr.length;
    for(var i = 0; i < length; i++){
        var listener = arr[i];
        listener.apply(listener, data);
    }
};


const $3104dd1e56b57153$var$bus = (0, (/*@__PURE__*/$parcel$interopDefault($6ac1a5641367fc62$exports)))();
var $3104dd1e56b57153$export$2e2bcd8739ae039 = $3104dd1e56b57153$var$bus;


const $a6409c313ea6ba3b$var$isHover = window.matchMedia("(hover: hover)");
mapboxgl.accessToken = "pk.eyJ1IjoiZm9sZGVyLWRldiIsImEiOiJja3FtbTZ3Y3kwZjNjMnNwcXNkMXRhcDF1In0.Rq-7aDZl6ZVsb594oDB-_A";
(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="map"]', {
    init () {
        // map init
        this.map = new mapboxgl.Map({
            container: this.element,
            style: "mapbox://styles/folder-dev/ckr3tay7z6xfo18quobgqfrr9",
            center: [
                -118.33954264488953,
                34.05278345886349
            ],
            zoom: this.getInitialZoom(),
            minZoom: 9,
            logoPosition: "bottom-right",
            attributionControl: false
        });
        // state
        this.state = {
            mapVisible: false,
            mapData: null,
            touchPopup: false,
            hoverPopup: false,
            permanentPopups: [],
            touchActive: true,
            hoverActive: true,
            hoverId: null
        };
        // popups
        this.touchPopup = null;
        this.hoverPopup = null;
        this.permanentPopups = [];
        // bound methods
        this.handleEnter = this.handleEnter.bind(this);
        this.handleExit = this.handleExit.bind(this);
        this.handleSetLocation = this.handleSetLocation.bind(this);
        this.handleClosePermanentPopup = this.handleClosePermanentPopup.bind(this);
        this.handleResetMap = this.handleResetMap.bind(this);
    },
    connected () {
        this.map.on("load", ()=>{
            this.addSource();
            this.loadIcons();
            this.addControls();
            this.addClusters();
            this.addClustersCount();
            this.addCustomUnclusteredPoints();
            this.addPopups();
            this.handleClusterClicks();
            this.setInitialLocation();
            if ($a6409c313ea6ba3b$var$isHover.matches) {
                this.handlePointHovers();
                this.handleClusterHovers();
                this.handlePointClicks();
            } else this.handlePointTaps();
            // Disable tap drag zoom: https://docs.mapbox.com/mapbox-gl-js/api/handlers/#touchzoomrotatehandler
            this.map.touchZoomRotate._tapDragZoom.disable();
        });
        this.stopObserving = (0, (/*@__PURE__*/$parcel$interopDefault($22560deee8d90fe2$exports)))(this.element, {}, this.handleEnter, this.handleExit);
        (0, $3104dd1e56b57153$export$2e2bcd8739ae039).on("map:set-location", this.handleSetLocation);
        (0, $3104dd1e56b57153$export$2e2bcd8739ae039).on("map:close-permanent-popup", this.handleClosePermanentPopup);
        (0, $3104dd1e56b57153$export$2e2bcd8739ae039).on("map:reset", this.handleResetMap);
    },
    disconnected () {
        this.stopObserving();
        this.map.remove();
        this.map = null;
        (0, $3104dd1e56b57153$export$2e2bcd8739ae039).off("map:set-location", this.handleSetLocation);
        (0, $3104dd1e56b57153$export$2e2bcd8739ae039).off("map:close-permanent-popup", this.handleClosePermanentPopup);
        (0, $3104dd1e56b57153$export$2e2bcd8739ae039).off("map:reset", this.handleResetMap);
    },
    getInitialZoom () {
        return window.innerWidth > 1024 ? 11 : window.innerWidth > 650 ? 10 : 9;
    },
    addSource () {
        this.map.addSource("galleries", {
            type: "geojson",
            data: `${window.SITE_BASE}/data/locations`,
            cluster: true,
            clusterMaxZoom: 14,
            clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
        });
    },
    loadIcons () {
        (0, $13c3ef9ba45958e0$export$2e2bcd8739ae039).forEach((icon)=>{
            let customIcon = new Image(120, 120);
            customIcon.onload = ()=>this.map.addImage(icon.name, customIcon);
            customIcon.src = icon.src;
        });
    },
    addControls () {
        this.map.addControl(new mapboxgl.NavigationControl({
            showCompass: false
        }), "bottom-left");
        this.map.addControl(new mapboxgl.AttributionControl({
            compact: true
        }), "bottom-right");
    },
    addClusters () {
        this.map.addLayer({
            id: "clusters",
            type: "circle",
            source: "galleries",
            filter: [
                "has",
                "point_count"
            ],
            paint: {
                "circle-color": [
                    "step",
                    [
                        "get",
                        "point_count"
                    ],
                    (0, $6999c02c9fa8589c$export$8f45430ccf837300).green,
                    4,
                    (0, $6999c02c9fa8589c$export$8f45430ccf837300).blue,
                    6,
                    (0, $6999c02c9fa8589c$export$8f45430ccf837300).red,
                    8,
                    (0, $6999c02c9fa8589c$export$8f45430ccf837300).yellow
                ],
                "circle-radius": 25,
                "circle-stroke-width": 1,
                "circle-stroke-color": "#000"
            }
        });
    },
    addClustersCount () {
        this.map.addLayer({
            id: "cluster-count",
            type: "symbol",
            source: "galleries",
            filter: [
                "has",
                "point_count"
            ],
            layout: {
                "text-field": "{point_count_abbreviated}",
                "text-font": [
                    "Theinhardt Bold"
                ],
                "text-size": 23,
                "text-offset": [
                    -0.03,
                    -0.055
                ]
            }
        });
    },
    addCustomUnclusteredPoints () {
        this.map.addLayer({
            id: "unclustered-point",
            type: "symbol",
            source: "galleries",
            filter: [
                "!has",
                "point_count"
            ],
            layout: {
                "icon-image": [
                    "get",
                    "icon"
                ],
                "icon-size": 0.25,
                "icon-allow-overlap": true
            }
        });
    },
    addPopups () {
        this.touchPopup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: [
                0,
                -22
            ]
        });
        this.hoverPopup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: [
                0,
                -22
            ]
        });
    },
    renderPopups (e) {
        const { touchPopup: touchPopup, hoverPopup: hoverPopup, touchActive: touchActive, hoverActive: hoverActive } = this.state;
        if (touchActive && touchPopup) {
            if (this.touchPopup) this.openPopup(touchPopup, e, this.touchPopup, true);
        } else if (this.touchPopup) this.touchPopup.remove();
        if (hoverActive && hoverPopup) {
            if (this.hoverPopup) this.openPopup(hoverPopup, e, this.hoverPopup);
        } else if (this.hoverPopup) this.hoverPopup.remove();
    },
    duplicatePopupCheck (featureA, features) {
        try {
            return features.find((feature)=>{
                console.log(featureA, feature);
                return featureA.properties.id === feature.properties.id;
            });
        } catch (e) {
            return false;
        }
    },
    openPopup (location, event, popup, touch = false) {
        const coordinates = location.geometry.coordinates.slice();
        const title = location.properties.title;
        const url = location.properties.url;
        if (event) while(Math.abs(event.lngLat.lng - coordinates[0]) > 180)coordinates[0] += event.lngLat.lng > coordinates[0] ? 360 : -360;
        const arrowLink = touch ? '&nbsp;<span class="link-arrow">→</span>' : "";
        popup.setLngLat(coordinates).setHTML(`<a href="${url}">${title}${arrowLink}</a>`).addTo(this.map);
    },
    handleClusterClicks () {
        this.map.on("click", "clusters", (e)=>{
            const features = this.map.queryRenderedFeatures(e.point, {
                layers: [
                    "clusters"
                ]
            });
            const clusterId = features[0].properties.cluster_id;
            this.map.getSource("galleries").getClusterExpansionZoom(clusterId, (err, zoom)=>{
                if (err) return;
                this.map.easeTo({
                    center: features[0].geometry.coordinates,
                    zoom: zoom
                });
            });
        });
    },
    handlePointTaps () {
        this.map.on("click", "unclustered-point", (e)=>{
            e.preventDefault();
            if (this.duplicatePopupCheck(e.features[0], this.state.permanentPopups)) this.state.touchPopup = false;
            else this.state.touchPopup = e.features[0];
            this.renderPopups(e);
        });
        // on tap-outside
        this.map.on("click", (e)=>{
            if (e.defaultPrevented === false) {
                this.state.touchPopup = false;
                this.renderPopups();
            }
        });
    },
    /**
   * Use mousemove instead of mouseenter for more responsive hovers
   * https://docs.mapbox.com/mapbox-gl-js/example/hover-styles/
   */ handlePointHovers () {
        this.map.on("mousemove", "unclustered-point", (e)=>{
            if (e.features.length > 0) {
                if (e.features[0].properties.uri !== this.state.hoverId) {
                    this.state.hoverId = e.features[0].properties.uri;
                    this.map.getCanvas().style.cursor = "pointer";
                    if (this.duplicatePopupCheck(e.features[0], this.state.permanentPopups)) this.state.hoverPopup = false;
                    else this.state.hoverPopup = e.features[0];
                    this.renderPopups(e);
                }
            }
        });
        this.map.on("mouseleave", "unclustered-point", (e)=>{
            this.map.getCanvas().style.cursor = "";
            this.state.hoverId = null;
            this.state.hoverPopup = false;
            this.renderPopups(e);
        });
    },
    handleClusterHovers () {
        this.map.on("mouseenter", "clusters", ()=>{
            this.map.getCanvas().style.cursor = "pointer";
        });
        this.map.on("mouseleave", "clusters", ()=>{
            this.map.getCanvas().style.cursor = "";
        });
    },
    handlePointClicks () {
        this.map.on("click", "unclustered-point", (e)=>{
            const { url: url, uri: uri } = e.features[0].properties;
            const currentUri = (0, $6999c02c9fa8589c$export$6483924f57bebc09)(window.GWLA_APP.state.location);
            if (currentUri !== uri) {
                window.GWLA_HISTORY.push(window.location.pathname);
                window.GWLA_APP.go(url);
            }
        });
    },
    /**
   * Set initial location if starting on a gallery page
   */ async setInitialLocation () {
        const currentUri = (0, $6999c02c9fa8589c$export$6483924f57bebc09)(window.GWLA_APP.state.location);
        const GalleryViewRegex = new RegExp("^index/.+");
        if (GalleryViewRegex.test(currentUri)) this.handleSetLocation(currentUri);
    },
    /**
   * Resize map when it re-enters viewport.
   * Handles mobile map size bug
   */ handleEnter () {
        this.state.mapVisible = true;
        if (this.map) this.map.resize();
    },
    handleExit () {
        this.state.mapVisible = false;
    },
    /**
   * Flys to location based on uri
   */ async handleSetLocation (uri) {
        // Exit if map is hidden (mobile views)
        if (!this.state.mapVisible) return;
        // 1. Fetch data if necessary
        if (!this.state.mapData) {
            const response = await fetch(`${window.SITE_BASE}/data/locations`);
            this.state.mapData = await response.json();
        }
        // 2. Lookup locations by uri, and fly to or fit to if possible
        try {
            const locations = this.state.mapData.features.filter((element)=>element.properties.uri === uri);
            if (locations.length === 1) {
                const location = locations[0];
                // Set fly to options
                let options = {
                    center: location.geometry.coordinates
                };
                // -> only zoom in when zoomed out
                if (this.map.getZoom() < 15) options.zoom = 15;
                // -> disable curve when zoomed in
                if (this.map.getZoom() >= 15 && this.map.getBounds().contains(location.geometry.coordinates)) options.curve = 0;
                // Fly to location
                this.map.flyTo(options);
                // Open permanent popups
                this.createPermanentPopups(locations);
                this.state.touchPopup = false;
                this.renderPopups();
            } else if (locations.length > 1) {
                const geojson = {
                    "type": "FeatureCollection",
                    "features": locations
                };
                // Fit geojson, unless points are near each other
                // in which case zoom to the center of the points
                const geoBounds = (0, $ef50c33c64ec8420$export$2e2bcd8739ae039)(geojson);
                const geoArea = (0, $17e543fcbc4d550c$export$2e2bcd8739ae039)((0, $f00c2b5e96c21de4$export$2e2bcd8739ae039)(geoBounds));
                if (geoArea > 10000) this.map.fitBounds(geoBounds, {
                    padding: 150
                });
                else {
                    var _geoCenter_geometry;
                    const geoCenter = (0, $3ca9c20d67fae5ec$export$2e2bcd8739ae039)(geojson);
                    this.map.flyTo({
                        center: geoCenter === null || geoCenter === void 0 ? void 0 : (_geoCenter_geometry = geoCenter.geometry) === null || _geoCenter_geometry === void 0 ? void 0 : _geoCenter_geometry.coordinates,
                        zoom: 19
                    });
                }
                // Open permanent popups
                this.createPermanentPopups(locations);
                this.state.touchPopup = false;
                this.renderPopups();
            }
        } catch (e) {}
    },
    /**
   * Creates permanent popups used to label galleries
   */ createPermanentPopups (locations) {
        // Close existing permanent popups
        this.closePermanentPopups();
        // Create new popups
        locations.forEach((location)=>{
            const coordinates = location.geometry.coordinates.slice();
            const title = location.properties.title;
            const popup = new mapboxgl.Popup({
                closeButton: false,
                closeOnClick: false,
                offset: [
                    0,
                    -22
                ]
            }).setLngLat(coordinates).setHTML(`<span class="pointer-events-none">${title}</span>`).addTo(this.map);
            this.permanentPopups.push(popup);
        });
        // Save locations to state for duplicate popup check
        this.state.permanentPopups = locations;
    },
    /**
   * Destroys existing permanent popups
   */ closePermanentPopups () {
        this.permanentPopups.forEach((popup)=>{
            if (popup.isOpen()) popup.remove();
        });
        this.permanentPopups = [];
        this.state.permanentPopups = [];
    },
    /**
   * Closes permanent popup
   */ handleClosePermanentPopup () {
        this.closePermanentPopups();
    },
    handleResetMap () {
        this.map.flyTo({
            center: [
                -118.33954264488953,
                34.05278345886349
            ],
            zoom: this.getInitialZoom(),
            bearing: 0,
            pitch: 0
        });
    }
});



var $bbe186f9413d552f$exports = {};
$bbe186f9413d552f$exports = $bbe186f9413d552f$var$Element;
function $bbe186f9413d552f$var$Element(svgText) {
    var parser = new DOMParser(), xmlText = "<svg xmlns='http://www.w3.org/2000/svg'>" + svgText + "</svg>", docElem = parser.parseFromString(xmlText, "text/xml").documentElement;
    var node = docElem.firstChild;
    document.importNode(node, true);
    return node;
}


function $0458c39d24b2e7ef$export$2e2bcd8739ae039(array) {
    if (!Array.isArray(array)) throw new TypeError("Expected an array");
    return array[Math.floor(Math.random() * array.length)];
}
$0458c39d24b2e7ef$export$2e2bcd8739ae039.multiple = (array, count)=>{
    if (!(Number.isInteger(count) && count >= 0)) throw new TypeError("Expected a non-negative integer");
    return [
        ...Array.from({
            length: count
        })
    ].map(()=>$0458c39d24b2e7ef$export$2e2bcd8739ae039(array));
};


/**
 * Draws SVG with various corner shapes
 * as the background of an element
 * 
 * Notes:
 * - Bevel, Curve, Sweep, Notch, false (normal corner)
 * - We shrink 1px around egde of svg to support 1px stroke
 * 
 * Enhancements:
 * - Support radius percentage
 * - Calc inset based on stroke width for variable stroke
 */ (0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="corner-shape"]', {
    init () {
        this.radius = parseInt(this.element.dataset.radius) || 50;
        const shapes = [
            [
                "bevel",
                false,
                "curve",
                false
            ],
            [
                false,
                "curve",
                false,
                "curve"
            ],
            [
                false,
                "curve",
                "bevel",
                false
            ],
            [
                "bevel",
                "bevel",
                "bevel",
                "bevel"
            ],
            [
                "bevel",
                "bevel",
                false,
                "curve"
            ],
            [
                false,
                "bevel",
                "curve",
                "bevel"
            ]
        ];
        // Get corner from option or select random
        try {
            let parsed = JSON.parse(this.element.dataset.corners);
            parsed = parsed.map((item)=>item === "false" ? false : item === "true" ? true : item);
            this.corners = parsed.length === 4 ? parsed : (0, $0458c39d24b2e7ef$export$2e2bcd8739ae039)(shapes);
        } catch (e) {
            this.corners = (0, $0458c39d24b2e7ef$export$2e2bcd8739ae039)(shapes);
        }
        // SVG init
        this.$svg = (0, (/*@__PURE__*/$parcel$interopDefault($bbe186f9413d552f$exports)))(`<svg preserveAspectRatio="none"><g transform="translate(0.5,0.5)"><path /></g></svg>`);
        this.$g = this.$svg.querySelector("g");
        this.$path = this.$svg.querySelector("path");
        this.element.appendChild(this.$svg);
        this.render = this.render.bind(this);
        this.resizeObserver = new ResizeObserver(this.render);
    },
    connected () {
        this.render();
        this.resizeObserver.observe(this.element);
    },
    disconnected () {
        this.resizeObserver.unobserve(this.element);
    },
    drawCorner (corner, shape, w, h, r, d) {
        if (!shape) switch(corner){
            case 0:
                d.push("h", r, "v", r);
                break;
            case 1:
                d.push("v", r, "h", -r);
                break;
            case 2:
                d.push("h", -r, "v", -r);
                break;
            case 3:
                d.push("v", -r, "h", r);
        }
        else if (shape === "notch") switch(corner){
            case 0:
                d.push("v", r, "h", r);
                break;
            case 1:
                d.push("h", -r, "v", r);
                break;
            case 2:
                d.push("v", -r, "h", -r);
                break;
            case 3:
                d.push("h", r, "v", -r);
        }
        else {
            if (shape === "curve" || shape === "scoop") {
                const sweep = +(shape === "curve");
                d.push("a", r, r, "0", 0, sweep);
            } else if (shape === "bevel") d.push("l");
            d.push(corner === 1 || corner === 2 ? -r : r);
            d.push(corner === 2 || corner === 3 ? -r : r);
        }
    },
    adjustedRadius (r, w, h) {
        if (r > w / 3 || r > h / 3) return Math.min(w, h) / 3;
        else return r;
    },
    render () {
        const inset = 2 // space for stroke
        ;
        const w = this.element.offsetWidth;
        const h = this.element.offsetHeight;
        const r = this.adjustedRadius(this.radius, w, h);
        // Set svg size
        this.$svg.setAttribute("width", w + inset);
        this.$svg.setAttribute("height", h + inset);
        this.$svg.setAttribute("viewBox", `0 0 ${w + inset} ${h + inset}`);
        // Open shape
        let d = [
            "M",
            r,
            "0"
        ];
        // Draw corners
        this.corners.forEach((shape, corner)=>{
            switch(corner){
                case 0:
                    d.push("h", w - r * 2);
                    break;
                case 1:
                    d.push("v", h - r * 2);
                    break;
                case 2:
                    d.push("h", -w + r * 2);
                    break;
                case 3:
                    d.push("v", -h + r * 2);
            }
            this.drawCorner(corner, shape, w, h, r, d);
        });
        // Close shape
        d.push("Z");
        this.$path.setAttribute("d", d.join(" "));
    }
});



var $de02db4f60a878c8$exports = {};
/*
 * Walkway.js
 *
 * Copyright 2016, Connor Atherton - http://connoratherton.com/
 * Released under the MIT Licence
 * http://opensource.org/licenses/MIT
 *
 * Github: http://github.com/ConnorAtherton/Walkway
 */ // Export Walkway depending on environment (AMD, CommonJS or Browser global)
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(factory);
    else // CommonJS
    $de02db4f60a878c8$exports = factory();
})($de02db4f60a878c8$exports, function factory(exports) {
    "use strict";
    /*
   * Shim for requestAnimationFrame on older browsers
   */ var lastTime = 0;
    window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    window.cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
    if (!window.requestAnimationFrame) window.requestAnimationFrame = function(callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function() {
            callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
    };
    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function(id) {
        clearTimeout(id);
    };
    /*
   * Easing Functions - inspired from http://gizma.com/easing/
   * only considering the t value for the range [0, 1] => [0, 1]
   *
   * Taken from https://gist.github.com/gre/1650294
   */ var EasingFunctions = {
        // no easing, no acceleration
        linear: function(t) {
            return t;
        },
        // accelerating from zero velocity
        easeInQuad: function(t) {
            return t * t;
        },
        // decelerating to zero velocity
        easeOutQuad: function(t) {
            return t * (2 - t);
        },
        // acceleration until halfway, then deceleration
        easeInOutQuad: function(t) {
            return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        // accelerating from zero velocity
        easeInCubic: function(t) {
            return t * t * t;
        },
        // decelerating to zero velocity
        easeOutCubic: function(t) {
            return --t * t * t + 1;
        },
        // acceleration until halfway, then deceleration
        easeInOutCubic: function(t) {
            return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        // accelerating from zero velocity
        easeInQuart: function(t) {
            return t * t * t * t;
        },
        // decelerating to zero velocity
        easeOutQuart: function(t) {
            return 1 - --t * t * t * t;
        },
        // acceleration until halfway, then deceleration
        easeInOutQuart: function(t) {
            return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        // accelerating from zero velocity
        easeInQuint: function(t) {
            return t * t * t * t * t;
        },
        // decelerating to zero velocity
        easeOutQuint: function(t) {
            return 1 + --t * t * t * t * t;
        },
        // acceleration until halfway, then deceleration
        easeInOutQuint: function(t) {
            return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
    };
    /*
   * Creates a selector used to select all element to animate
   * Currently only supports *path*, *line*, and *polyline* svg elements
   *
   * @param {string} selector The selector of the parent element
   * @returns {string} the complete selector
   * @private
   */ function _createSelector(selector) {
        var supported = [
            "path",
            "line",
            "polyline"
        ];
        var newSelector = supported.reduce(function(prev, curr) {
            return prev + selector + " " + curr + ", ";
        }, "");
        // chop the last , from the string
        return newSelector.slice(0, -2);
    }
    /*
   * All Walkway instances present on the current page. This is needed for when
   * the tab loses focus and we need to force each animation to finish.
   */ var _elements = [];
    var _instances = [];
    document.addEventListener("visibilitychange", function() {
        if (!document.hidden) return;
        for(var i = 0, instancesLen = _instances.length; i < instancesLen; i++)_instances[i].cancel();
        for(var j = 0, elementsLen = _elements.length; j < elementsLen; j++)_elements[j].complete();
    }, false);
    /*
   * Walkway constructor function
   * opts.selector is the only mandatory param and can be passed in alone
   * as a string
   *
   * @param {object} opts the configuration objects for the instance.
   * @returns {walkway}
   */ function Walkway(opts) {
        if (!(this instanceof Walkway)) return new Walkway(opts);
        if (typeof opts === "string") opts = {
            selector: opts
        };
        if (!opts.selector) return this.error("A selector needs to be specified");
        this.opts = opts;
        this.selector = opts.selector;
        this.duration = opts.duration || 500;
        this.easing = typeof opts.easing === "function" ? opts.easing : EasingFunctions[opts.easing] || EasingFunctions.easeInOutCubic;
        this.id = false;
        this.elements = this.getElements();
        this.callback = opts.callback;
        this.setInitialStyles();
        _elements = _elements.concat(this.elements);
        _instances.push(this);
    }
    Walkway.prototype = {
        constructor: Walkway,
        /*
     * Prints an error message to the console
     *
     * @param {string} message the message to be displayed
     * @returns {void}
     */ error: function(message) {
            console.error("Walkway error: " + message);
        },
        /*
     * Uses a pre-build selector to find and store elements to animate
     *
     * @returns {array} of Path instances
     */ getElements: function() {
            var self = this;
            var selector = _createSelector(this.selector);
            var els = document.querySelectorAll(selector);
            els = Array.prototype.slice.call(els);
            return els.map(function(el) {
                if (el.tagName === "path") return new Path(el, self.duration, self.easing);
                else if (el.tagName === "line") return new Line(el, self.duration, self.easing);
                else if (el.tagName === "polyline") return new Polyline(el, self.duration, self.easing);
            });
        },
        /*
     * Sets initial styles on all elements to be animated
     *
     * @returns {void}
     */ setInitialStyles: function() {
            this.elements.forEach(function(n) {
                n.el.style.strokeDasharray = n.length + " " + n.length;
                n.el.style.strokeDashoffset = n.length;
            });
        },
        /*
     * The general update loop for the animations.
     * Once individal paths are completed they are marked as such and
     * are not updated.
     *
     * @returns {void}
     */ draw: function(callback) {
            var counter = this.elements.length;
            var allComplete = this.elements.filter(function(el) {
                return el.done;
            }).length === counter;
            var element = null;
            var done = false;
            // Overwrite existing callback passed in with options
            this.callback = callback || this.callback;
            if (allComplete) {
                if (this.callback && typeof this.callback === "function") this.callback();
                this.cancel();
                return;
            }
            while(counter--){
                element = this.elements[counter];
                done = element.update();
                if (done) element.done = true;
            }
            this.id = window.requestAnimationFrame(this.draw.bind(this, callback));
        },
        cancel: function() {
            window.cancelAnimationFrame(this.id);
        },
        redraw: function() {
            this.cancel();
            this.elements.forEach(function(element) {
                element.reset();
            });
            this.draw();
        }
    };
    function WalkwayElement(el, duration, easing) {
        this.el = el;
        this.duration = duration;
        this.easing = easing;
        this.animationStart = null;
        this.animationStarted = false;
    }
    WalkwayElement.prototype = {
        constructor: WalkwayElement,
        /*
     * This contains the general update logic for all supported svg
     * elements.
     *
     * @returns {boolean} true if the animation is complete, false otherwise
     */ update: function() {
            if (!this.animationStarted) {
                this.animationStart = Date.now();
                this.animationStarted = true;
            }
            var progress = this.easing((Date.now() - this.animationStart) / this.duration);
            this.fill(progress);
            return progress >= 1 ? true : false;
        },
        fill: function(progress) {
            var value = Math.ceil(this.length * (1 - progress));
            this.el.style.strokeDashoffset = value < 0 ? 0 : Math.abs(value);
        },
        complete: function() {
            this.fill(1);
        },
        reset: function() {
            this.done = false;
            this.animationStart = 0;
            this.animationStarted = false;
            this.fill(0);
        }
    };
    /*
   * Constructor for new path instance
   *
   * @param {node} path actual dom node of the path
   * @param {string} duration how long the animation should take to complete
   * @param {string} easing the type of easing used - default is easeInOutCubic.
   * @returns {Path}
   */ function Path(path, duration, easing) {
        WalkwayElement.call(this, path, duration, easing);
        this.length = path.getTotalLength();
    }
    /*
   * Constructor for new Line instance
   *
   * @param {node} line actual dom node of the path
   * @param {string} duration how long the animation should take to complete
   * @param {string} easing the type of easing used - default is easeInOutCubic.
   * @returns {line}
   */ function Line(line, duration, easing) {
        WalkwayElement.call(this, line, duration, easing);
        this.length = getLineLength(line);
    }
    /*
   * Constructor for new Polyline instance
   *
   * @param {node} polyline actual dom node of the path
   * @param {string} duration how long the animation should take to complete
   * @param {string} easing the type of easing used - default is easeInOutCubic.
   * @returns {polyline}
   */ function Polyline(polyline, duration, easing) {
        WalkwayElement.call(this, polyline, duration, easing);
        this.length = getPolylineLength(polyline);
    }
    Path.prototype = Line.prototype = Polyline.prototype = Object.create(WalkwayElement.prototype);
    /*
   * Calculates the length of a polyline using pythagoras theorem for each line segment
   *
   * @param {node} polyline The polyline element to calculate length of
   * @returns {Number} Length of the polyline
   */ function getPolylineLength(polyline) {
        var dist = 0;
        var x1, x2, y1, y2;
        var i;
        var points = polyline.points.numberOfItems;
        for(i = 1; i < points; i++){
            x1 = polyline.points.getItem(i - 1).x;
            x2 = polyline.points.getItem(i).x;
            y1 = polyline.points.getItem(i - 1).y;
            y2 = polyline.points.getItem(i).y;
            dist += Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
        }
        return dist;
    }
    /*
   * Calculates the length a line using pythagoras theorem
   *
   * @param {node} line The line element to calculate length of
   * @returns {Number} Length of the line
   */ function getLineLength(line) {
        var x1 = line.getAttribute("x1");
        var x2 = line.getAttribute("x2");
        var y1 = line.getAttribute("y1");
        var y2 = line.getAttribute("y2");
        return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
    }
    return Walkway;
});


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="splash"]', {
    init () {
        this.walkway = new (0, (/*@__PURE__*/$parcel$interopDefault($de02db4f60a878c8$exports)))({
            selector: "#gallery-weekend-splash",
            duration: "2000"
        });
    },
    connected () {
        this.walkway.draw();
        this.element.classList.add("walkway-init");
    },
    disconnected () {}
});





(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="main-logo"]', {
    init () {
        this.walkway = new (0, (/*@__PURE__*/$parcel$interopDefault($de02db4f60a878c8$exports)))({
            selector: "#gallery-weekend-logo",
            duration: "1000"
        });
        this.handleClick = this.handleClick.bind(this);
    },
    connected () {
        this.walkway.draw();
        this.element.classList.add("walkway-init");
        this.element.addEventListener("click", this.handleClick);
    },
    disconnected () {
        this.element.removeEventListener("click", this.handleClick);
    },
    handleClick () {
        window.GWLA_SCROLL["/"] = 0;
        (0, $3104dd1e56b57153$export$2e2bcd8739ae039).emit("map:reset");
    }
});


function $23465f4677c1f584$export$2e2bcd8739ae039(arr, cb) {
    var i = 0, len = arr.length;
    for(; i < len; i++){
        if (!cb(arr[i], i, arr)) return false;
    }
    return true;
}


"use strict";
const $0e83632b90b75bec$var$SEP = "/";
// Types ~> static, param, any, optional
const $0e83632b90b75bec$var$STYPE = 0, $0e83632b90b75bec$var$PTYPE = 1, $0e83632b90b75bec$var$ATYPE = 2, $0e83632b90b75bec$var$OTYPE = 3;
// Char Codes ~> / : *
const $0e83632b90b75bec$var$SLASH = 47, $0e83632b90b75bec$var$COLON = 58, $0e83632b90b75bec$var$ASTER = 42, $0e83632b90b75bec$var$QMARK = 63;
function $0e83632b90b75bec$var$strip(str) {
    if (str === $0e83632b90b75bec$var$SEP) return str;
    str.charCodeAt(0) === $0e83632b90b75bec$var$SLASH && (str = str.substring(1));
    var len = str.length - 1;
    return str.charCodeAt(len) === $0e83632b90b75bec$var$SLASH ? str.substring(0, len) : str;
}
function $0e83632b90b75bec$var$split(str) {
    return (str = $0e83632b90b75bec$var$strip(str)) === $0e83632b90b75bec$var$SEP ? [
        $0e83632b90b75bec$var$SEP
    ] : str.split($0e83632b90b75bec$var$SEP);
}
function $0e83632b90b75bec$var$isMatch(arr, obj, idx) {
    idx = arr[idx];
    return obj.val === idx && obj.type === $0e83632b90b75bec$var$STYPE || (idx === $0e83632b90b75bec$var$SEP ? obj.type > $0e83632b90b75bec$var$PTYPE : obj.type !== $0e83632b90b75bec$var$STYPE && (idx || "").endsWith(obj.end));
}
function $0e83632b90b75bec$export$4659b591c19bdf3d(str, all) {
    var i = 0, tmp, segs = $0e83632b90b75bec$var$split(str), len = segs.length, l;
    var fn = $0e83632b90b75bec$var$isMatch.bind($0e83632b90b75bec$var$isMatch, segs);
    for(; i < all.length; i++){
        tmp = all[i];
        if ((l = tmp.length) === len || l < len && tmp[l - 1].type === $0e83632b90b75bec$var$ATYPE || l > len && tmp[l - 1].type === $0e83632b90b75bec$var$OTYPE) {
            if ((0, $23465f4677c1f584$export$2e2bcd8739ae039)(tmp, fn)) return tmp;
        }
    }
    return [];
}
function $0e83632b90b75bec$export$98e6a39c04603d36(str) {
    if (str === $0e83632b90b75bec$var$SEP) return [
        {
            old: str,
            type: $0e83632b90b75bec$var$STYPE,
            val: str,
            end: ""
        }
    ];
    var c, x, t, sfx, nxt = $0e83632b90b75bec$var$strip(str), i = -1, j = 0, len = nxt.length, out = [];
    while(++i < len){
        c = nxt.charCodeAt(i);
        if (c === $0e83632b90b75bec$var$COLON) {
            j = i + 1; // begining of param
            t = $0e83632b90b75bec$var$PTYPE; // set type
            x = 0; // reset mark
            sfx = "";
            while(i < len && nxt.charCodeAt(i) !== $0e83632b90b75bec$var$SLASH){
                c = nxt.charCodeAt(i);
                if (c === $0e83632b90b75bec$var$QMARK) {
                    x = i;
                    t = $0e83632b90b75bec$var$OTYPE;
                } else if (c === 46 && sfx.length === 0) sfx = nxt.substring(x = i);
                i++; // move on
            }
            out.push({
                old: str,
                type: t,
                val: nxt.substring(j, x || i),
                end: sfx
            });
            // shorten string & update pointers
            nxt = nxt.substring(i);
            len -= i;
            i = 0;
            continue; // loop
        } else if (c === $0e83632b90b75bec$var$ASTER) {
            out.push({
                old: str,
                type: $0e83632b90b75bec$var$ATYPE,
                val: nxt.substring(i),
                end: ""
            });
            continue; // loop
        } else {
            j = i;
            while(i < len && nxt.charCodeAt(i) !== $0e83632b90b75bec$var$SLASH)++i; // skip to next slash
            out.push({
                old: str,
                type: $0e83632b90b75bec$var$STYPE,
                val: nxt.substring(j, i),
                end: ""
            });
            // shorten string & update pointers
            nxt = nxt.substring(i);
            len -= i;
            i = j = 0;
        }
    }
    return out;
}
function $0e83632b90b75bec$export$78e3044358792147(str, arr) {
    var i = 0, x, y, segs = $0e83632b90b75bec$var$split(str), out = {};
    for(; i < arr.length; i++){
        x = segs[i];
        y = arr[i];
        if (x === $0e83632b90b75bec$var$SEP) continue;
        if (x !== void 0 && y.type | 2 === $0e83632b90b75bec$var$OTYPE) out[y.val] = x.replace(y.end, "");
    }
    return out;
}


var $b50c183501f1ff74$var$r = new Map;
function $b50c183501f1ff74$var$a(n) {
    return n.replace(window.location.origin, "");
}
function $b50c183501f1ff74$var$o(n, r) {
    var a = "", o = "", i = n.split(/#|\?/), c = i[0], u = i.slice(1);
    c = (c = c.replace(/\/$/g, "")) || "/";
    for(var l = 0; l < u.length; l++){
        var f = n.split(u[l])[0];
        "?" === f[f.length - 1] && (o = u[l]), "#" === f[f.length - 1] && (a = u[l]);
    }
    var h = (0, $0e83632b90b75bec$export$4659b591c19bdf3d)(c, r.map(function(n) {
        return n.matcher;
    })), s = r.filter(function(n) {
        return n.path === h[0].old;
    })[0];
    return h[0] ? Object.assign({}, s, {
        params: (0, $0e83632b90b75bec$export$78e3044358792147)(c, h),
        hash: a,
        search: o,
        pathname: c,
        location: n
    }) : null;
}
function $b50c183501f1ff74$export$2e2bcd8739ae039(t, e) {
    void 0 === e && (e = [
        "*"
    ]);
    var i, c = document.querySelector(t), u = [], l = {};
    e = e.concat(e.indexOf("*") < 0 ? "*" : []).reduce(function(n, t) {
        return "function" == typeof t ? (u.push(t), n) : n.concat(t);
    }, []).map(function(t) {
        return t.path ? Object.assign({}, t, {
            matcher: (0, $0e83632b90b75bec$export$98e6a39c04603d36)(t.path)
        }) : {
            path: t,
            matcher: (0, $0e83632b90b75bec$export$98e6a39c04603d36)(t)
        };
    });
    var f = $b50c183501f1ff74$var$o($b50c183501f1ff74$var$a(window.location.href), e), h = Object.assign({
        previousDocument: null
    }, f);
    function s(n) {
        return l[n] ? l[n].map(function(n) {
            return n(h);
        }) : [];
    }
    function p(n, t, e, r) {
        h.previousDocument = n.cloneNode(!0), Promise.all(u.concat(e.handler || []).map(function(n) {
            return n(h);
        })).then(function() {
            requestAnimationFrame(function() {
                c.innerHTML = t, s("after"), e.hash && s("hash");
            });
        });
    }
    function d(n, e, a) {
        if (!e) return window.location.href = n;
        fetch(n, {
            credentials: "include"
        }).then(function(n) {
            return n.text();
        }).then(function(o) {
            var i = (new window.DOMParser).parseFromString(o, "text/html"), c = [
                i,
                i.querySelector(t).innerHTML
            ];
            $b50c183501f1ff74$var$r.set(n, c), a && a(c[0], c[1], e);
        });
    }
    function m(n, t, e) {
        i = function() {
            var e = $b50c183501f1ff74$var$r.get(n);
            e && !1 !== t.cache ? p(e[0], e[1], t) : d(n, t, p);
        }, Object.assign(h, t), Promise.all(s("before")).then(i);
    }
    function v(n) {
        var t = $b50c183501f1ff74$var$a(n);
        return [
            t,
            $b50c183501f1ff74$var$o(t, e)
        ];
    }
    return document.body.addEventListener("click", function(n) {
        if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.defaultPrevented)) {
            for(var t = n.target; t && (!t.href || "A" !== t.nodeName);)t = t.parentNode;
            if (!t) return n;
            var e = v(t.href), r = e[0], a = e[1];
            return a.ignore ? n : h.pathname === a.pathname && a.hash ? (n.preventDefault(), Object.assign(h, a), s("hash"), n) : window.location.origin !== t.origin || t.hasAttribute("download") || "_blank" === t.target || /^(?:mailto|tel):/.test(t.href) || t.classList.contains("no-ajax") ? n : (n.preventDefault(), h.location !== r && m(r, a), s("navigate"), !1);
        }
    }), window.addEventListener("popstate", function(n) {
        if (n.target.location.pathname !== h.pathname) return m.apply(void 0, v(n.target.location.href).concat([
            !0
        ])), !1;
    }), {
        get state () {
            return h;
        },
        go: function(n) {
            i = null, m.apply(void 0, v(n).concat([
                !1
            ]));
        },
        load: function(n, t) {
            return d.apply(void 0, v(n).concat([
                t
            ]));
        },
        on: function(n, t) {
            return l[n] = l[n] ? l[n].concat(t) : [
                t
            ], function() {
                return l[n].slice(l[n].indexOf(t), 1);
            };
        }
    };
}





let $d7437ec6a852468a$var$previousLocation = window.location.pathname;
window.GWLA_HISTORY = [];
window.GWLA_SCROLL = {};
let $d7437ec6a852468a$var$loadingTimeout = null;
let $d7437ec6a852468a$var$pageCount = 0;
const $d7437ec6a852468a$var$app = window.GWLA_APP = (0, $b50c183501f1ff74$export$2e2bcd8739ae039)("#content", [
    {
        path: `${window.SITE_BASE}/index/:gallery`,
        handler (state) {
            const currentUri = (0, $6999c02c9fa8589c$export$6483924f57bebc09)(state.location);
            (0, $3104dd1e56b57153$export$2e2bcd8739ae039).emit("map:set-location", currentUri);
        }
    }
]);
// Set previous location on link click
// -> Using delegate instead of app.on('before'),
// since `before` does not run on same route
(0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))(document.body, "a[href]", "click", (e)=>{
    $d7437ec6a852468a$var$previousLocation = window.location.pathname;
    window.GWLA_HISTORY.push(window.location.pathname);
}, true);
// Close existing popup on `before` navigate
$d7437ec6a852468a$var$app.on("before", (state)=>{
    // Keep track of previous scroll positions on different pages
    window.GWLA_SCROLL[window.location.pathname] = window.scrollY;
    (0, $3104dd1e56b57153$export$2e2bcd8739ae039).emit("map:close-permanent-popup");
});
$d7437ec6a852468a$var$app.on("navigate", (state)=>{
    // Don't do anything when navigating to same route
    if ($d7437ec6a852468a$var$previousLocation === state.location) return;
    // Add loading timeout after 250ms
    $d7437ec6a852468a$var$loadingTimeout = setTimeout(()=>{
        document.documentElement.classList.add("loading");
    }, 250);
    $d7437ec6a852468a$var$pageCount++;
});
$d7437ec6a852468a$var$app.on("after", ({ previousDocument: previousDocument, location: location })=>{
    // Clear loading timeout
    clearTimeout($d7437ec6a852468a$var$loadingTimeout);
    document.documentElement.classList.remove("loading");
    // Update title
    document.title = previousDocument.title;
    // Update route
    window.history.pushState({}, "", location);
    // Update opengraph
    let opengraphTags = [
        ...previousDocument.querySelectorAll('[property^="og:"]')
    ];
    opengraphTags.forEach((tag)=>{
        let existingOpengraphTag = document.querySelector(`[property="${tag.getAttribute("property")}"`);
        if (existingOpengraphTag) existingOpengraphTag.content = tag.content;
    });
    // Update classes
    $d7437ec6a852468a$var$updateClasses(previousDocument);
    // Reset scroll position
    if (window.GWLA_SCROLL[location]) window.scrollTo(0, window.GWLA_SCROLL[location]);
    else window.scrollTo(0, 0);
});
/**
 * Add a `data-operator-classes` attribute to all elements
 * outside the operator viewport that should have their 
 * classList updated on navigate.
 */ function $d7437ec6a852468a$var$updateClasses(previousDocument) {
    const oldElements = [
        ...previousDocument.querySelectorAll("[data-operator-classes]")
    ];
    const newElements = [
        ...document.querySelectorAll("[data-operator-classes]")
    ];
    newElements.forEach((newElement, i)=>{
        let oldElement = oldElements[i];
        let oldClasses = [
            ...oldElement.classList
        ];
        let newClasses = [
            ...newElement.classList
        ];
        let classesToRemove = newClasses.filter((x)=>!oldClasses.includes(x));
        let classesToAdd = oldClasses.filter((x)=>!newClasses.includes(x));
        newElement.classList.remove(...classesToRemove);
        newElement.classList.add(...classesToAdd);
    });
}
(0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))(document.body, "[data-operator-back]", "click", (e)=>{
    if (window.GWLA_HISTORY.length >= 2) {
        e.preventDefault();
        e.stopPropagation();
        // 1. remove current item from history stack
        const currentItem = window.GWLA_HISTORY.pop();
        // 2. get last item from history stack (and remove)
        let lastItem = window.GWLA_HISTORY.pop();
        // 3. if the current page was a gallery view,
        // iterate through history stack for the first
        // non-gallery item
        const GalleryViewRegex = new RegExp("^index/.+");
        if (GalleryViewRegex.test((0, $6999c02c9fa8589c$export$6483924f57bebc09)(currentItem))) while(lastItem && GalleryViewRegex.test((0, $6999c02c9fa8589c$export$6483924f57bebc09)(lastItem)))lastItem = window.GWLA_HISTORY.pop();
        // 4. navigate back
        $d7437ec6a852468a$var$app.go(lastItem || "/");
    }
}, true);


(0, $65b4de7ca7b2ca88$export$2e2bcd8739ae039)();
(0, $0bbedd1cf2657f4d$export$2e2bcd8739ae039)();
(0, $0ffb30c7ca5554ae$export$2e2bcd8739ae039)();
(0, $ad4b2b72846e4da5$export$2e2bcd8739ae039)();
(0, (/*@__PURE__*/$parcel$interopDefault($93307c02d3900b6f$exports)))();





})();
//# sourceMappingURL=bundle.js.map
